"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Chainsight Open API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxApi = exports.TxApiFactory = exports.TxApiFp = exports.TxApiAxiosParamCreator = exports.RuleApi = exports.RuleApiFactory = exports.RuleApiFp = exports.RuleApiAxiosParamCreator = exports.RequestDemoApi = exports.RequestDemoApiFactory = exports.RequestDemoApiFp = exports.RequestDemoApiAxiosParamCreator = exports.ReportTicketApi = exports.ReportTicketApiFactory = exports.ReportTicketApiFp = exports.ReportTicketApiAxiosParamCreator = exports.ReadmeApi = exports.ReadmeApiFactory = exports.ReadmeApiFp = exports.ReadmeApiAxiosParamCreator = exports.ProjectApi = exports.ProjectApiFactory = exports.ProjectApiFp = exports.ProjectApiAxiosParamCreator = exports.MediumApi = exports.MediumApiFactory = exports.MediumApiFp = exports.MediumApiAxiosParamCreator = exports.MarketPriceApi = exports.MarketPriceApiFactory = exports.MarketPriceApiFp = exports.MarketPriceApiAxiosParamCreator = exports.LabelCategoryApi = exports.LabelCategoryApiFactory = exports.LabelCategoryApiFp = exports.LabelCategoryApiAxiosParamCreator = exports.LabelApi = exports.LabelApiFactory = exports.LabelApiFp = exports.LabelApiAxiosParamCreator = exports.IncidentClusterApi = exports.IncidentClusterApiFactory = exports.IncidentClusterApiFp = exports.IncidentClusterApiAxiosParamCreator = exports.IncidentAddressScanApi = exports.IncidentAddressScanApiFactory = exports.IncidentAddressScanApiFp = exports.IncidentAddressScanApiAxiosParamCreator = exports.IncidentApi = exports.IncidentApiFactory = exports.IncidentApiFp = exports.IncidentApiAxiosParamCreator = exports.HolderGroupApi = exports.HolderGroupApiFactory = exports.HolderGroupApiFp = exports.HolderGroupApiAxiosParamCreator = exports.HolderAddressApi = exports.HolderAddressApiFactory = exports.HolderAddressApiFp = exports.HolderAddressApiAxiosParamCreator = exports.HolderApi = exports.HolderApiFactory = exports.HolderApiFp = exports.HolderApiAxiosParamCreator = exports.FlowLabelingApi = exports.FlowLabelingApiFactory = exports.FlowLabelingApiFp = exports.FlowLabelingApiAxiosParamCreator = exports.FeedbackApi = exports.FeedbackApiFactory = exports.FeedbackApiFp = exports.FeedbackApiAxiosParamCreator = exports.ExchangeApi = exports.ExchangeApiFactory = exports.ExchangeApiFp = exports.ExchangeApiAxiosParamCreator = exports.DomainApi = exports.DomainApiFactory = exports.DomainApiFp = exports.DomainApiAxiosParamCreator = exports.ContentfulApi = exports.ContentfulApiFactory = exports.ContentfulApiFp = exports.ContentfulApiAxiosParamCreator = exports.CheckApi = exports.CheckApiFactory = exports.CheckApiFp = exports.CheckApiAxiosParamCreator = exports.ChainApi = exports.ChainApiFactory = exports.ChainApiFp = exports.ChainApiAxiosParamCreator = exports.BlobApi = exports.BlobApiFactory = exports.BlobApiFp = exports.BlobApiAxiosParamCreator = exports.AssetApi = exports.AssetApiFactory = exports.AssetApiFp = exports.AssetApiAxiosParamCreator = exports.ApiKeyApi = exports.ApiKeyApiFactory = exports.ApiKeyApiFp = exports.ApiKeyApiAxiosParamCreator = exports.AddressScanBatchApi = exports.AddressScanBatchApiFactory = exports.AddressScanBatchApiFp = exports.AddressScanBatchApiAxiosParamCreator = exports.AddressScanApi = exports.AddressScanApiFactory = exports.AddressScanApiFp = exports.AddressScanApiAxiosParamCreator = exports.AddressLabelApi = exports.AddressLabelApiFactory = exports.AddressLabelApiFp = exports.AddressLabelApiAxiosParamCreator = exports.AddressCaseCommentApi = exports.AddressCaseCommentApiFactory = exports.AddressCaseCommentApiFp = exports.AddressCaseCommentApiAxiosParamCreator = exports.AddressCaseApi = exports.AddressCaseApiFactory = exports.AddressCaseApiFp = exports.AddressCaseApiAxiosParamCreator = exports.AddressApi = exports.AddressApiFactory = exports.AddressApiFp = exports.AddressApiAxiosParamCreator = exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiAxiosParamCreator = exports.WitnessDtoCategoryEnum = exports.UserFeedbackFormTargetProductEnum = exports.TxDtoTypeEnum = exports.ResultEntryTypeEnum = exports.ReportTicketDtoIssueTypeEnum = exports.ReportTicketDtoReportTypeEnum = exports.ReportTicketCreationIssueTypeEnum = exports.ReportTicketCreationReportTypeEnum = exports.ProjectMemberDtoAccessLevelEnum = exports.IncidentStatusCountStatusEnum = exports.IncidentDtoStatusEnum = exports.HolderUpdatesLevelEnum = exports.HolderLevelCountLevelEnum = exports.HolderDtoLevelEnum = exports.HolderCreationLevelEnum = exports.FlowLabelingDtoMethodEnum = exports.FlowLabelingDtoStatusEnum = exports.FlowLabelingCreationMethodEnum = exports.ChainDtoAddressFormatEnum = exports.ApiErrorCode = exports.ApiErrorStatusEnum = exports.AnonymousFeedbackFormTargetProductEnum = exports.AddressScanDtoStatusEnum = exports.AddressScanCreationMethodEnum = exports.AddressScanBatchDtoStatusEnum = exports.AddressScanBatchCreationFromBlobMethodEnum = exports.AddressCaseStatusCountStatusEnum = exports.AddressCaseLogDtoLevelEnum = exports.AddressCaseLogDtoStatusEnum = exports.AddressCaseLogDtoActionEnum = exports.AddressCaseLevelCountLevelEnum = exports.AddressCaseDtoLevelEnum = exports.AddressCaseDtoStatusEnum = exports.AddressCaseCreationLevelEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var AddressCaseCreationLevelEnum;
(function (AddressCaseCreationLevelEnum) {
    AddressCaseCreationLevelEnum["High"] = "HIGH";
    AddressCaseCreationLevelEnum["Medium"] = "MEDIUM";
    AddressCaseCreationLevelEnum["Low"] = "LOW";
})(AddressCaseCreationLevelEnum = exports.AddressCaseCreationLevelEnum || (exports.AddressCaseCreationLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressCaseDtoStatusEnum;
(function (AddressCaseDtoStatusEnum) {
    AddressCaseDtoStatusEnum["Open"] = "OPEN";
    AddressCaseDtoStatusEnum["InReview"] = "IN_REVIEW";
    AddressCaseDtoStatusEnum["Closed"] = "CLOSED";
})(AddressCaseDtoStatusEnum = exports.AddressCaseDtoStatusEnum || (exports.AddressCaseDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressCaseDtoLevelEnum;
(function (AddressCaseDtoLevelEnum) {
    AddressCaseDtoLevelEnum["High"] = "HIGH";
    AddressCaseDtoLevelEnum["Medium"] = "MEDIUM";
    AddressCaseDtoLevelEnum["Low"] = "LOW";
})(AddressCaseDtoLevelEnum = exports.AddressCaseDtoLevelEnum || (exports.AddressCaseDtoLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressCaseLevelCountLevelEnum;
(function (AddressCaseLevelCountLevelEnum) {
    AddressCaseLevelCountLevelEnum["High"] = "HIGH";
    AddressCaseLevelCountLevelEnum["Medium"] = "MEDIUM";
    AddressCaseLevelCountLevelEnum["Low"] = "LOW";
})(AddressCaseLevelCountLevelEnum = exports.AddressCaseLevelCountLevelEnum || (exports.AddressCaseLevelCountLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressCaseLogDtoActionEnum;
(function (AddressCaseLogDtoActionEnum) {
    AddressCaseLogDtoActionEnum["Create"] = "CREATE";
    AddressCaseLogDtoActionEnum["UpdateStatus"] = "UPDATE_STATUS";
    AddressCaseLogDtoActionEnum["UpdateLevel"] = "UPDATE_LEVEL";
    AddressCaseLogDtoActionEnum["Other"] = "OTHER";
})(AddressCaseLogDtoActionEnum = exports.AddressCaseLogDtoActionEnum || (exports.AddressCaseLogDtoActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressCaseLogDtoStatusEnum;
(function (AddressCaseLogDtoStatusEnum) {
    AddressCaseLogDtoStatusEnum["Open"] = "OPEN";
    AddressCaseLogDtoStatusEnum["InReview"] = "IN_REVIEW";
    AddressCaseLogDtoStatusEnum["Closed"] = "CLOSED";
})(AddressCaseLogDtoStatusEnum = exports.AddressCaseLogDtoStatusEnum || (exports.AddressCaseLogDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressCaseLogDtoLevelEnum;
(function (AddressCaseLogDtoLevelEnum) {
    AddressCaseLogDtoLevelEnum["High"] = "HIGH";
    AddressCaseLogDtoLevelEnum["Medium"] = "MEDIUM";
    AddressCaseLogDtoLevelEnum["Low"] = "LOW";
})(AddressCaseLogDtoLevelEnum = exports.AddressCaseLogDtoLevelEnum || (exports.AddressCaseLogDtoLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressCaseStatusCountStatusEnum;
(function (AddressCaseStatusCountStatusEnum) {
    AddressCaseStatusCountStatusEnum["Open"] = "OPEN";
    AddressCaseStatusCountStatusEnum["InReview"] = "IN_REVIEW";
    AddressCaseStatusCountStatusEnum["Closed"] = "CLOSED";
})(AddressCaseStatusCountStatusEnum = exports.AddressCaseStatusCountStatusEnum || (exports.AddressCaseStatusCountStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressScanBatchCreationFromBlobMethodEnum;
(function (AddressScanBatchCreationFromBlobMethodEnum) {
    AddressScanBatchCreationFromBlobMethodEnum["Taint"] = "TAINT";
    AddressScanBatchCreationFromBlobMethodEnum["Max"] = "MAX";
})(AddressScanBatchCreationFromBlobMethodEnum = exports.AddressScanBatchCreationFromBlobMethodEnum || (exports.AddressScanBatchCreationFromBlobMethodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressScanBatchDtoStatusEnum;
(function (AddressScanBatchDtoStatusEnum) {
    AddressScanBatchDtoStatusEnum["Pending"] = "PENDING";
    AddressScanBatchDtoStatusEnum["Running"] = "RUNNING";
    AddressScanBatchDtoStatusEnum["Completed"] = "COMPLETED";
})(AddressScanBatchDtoStatusEnum = exports.AddressScanBatchDtoStatusEnum || (exports.AddressScanBatchDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressScanCreationMethodEnum;
(function (AddressScanCreationMethodEnum) {
    AddressScanCreationMethodEnum["Taint"] = "TAINT";
    AddressScanCreationMethodEnum["Max"] = "MAX";
})(AddressScanCreationMethodEnum = exports.AddressScanCreationMethodEnum || (exports.AddressScanCreationMethodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AddressScanDtoStatusEnum;
(function (AddressScanDtoStatusEnum) {
    AddressScanDtoStatusEnum["Pending"] = "PENDING";
    AddressScanDtoStatusEnum["Submitted"] = "SUBMITTED";
    AddressScanDtoStatusEnum["Running"] = "RUNNING";
    AddressScanDtoStatusEnum["Completed"] = "COMPLETED";
    AddressScanDtoStatusEnum["Failed"] = "FAILED";
})(AddressScanDtoStatusEnum = exports.AddressScanDtoStatusEnum || (exports.AddressScanDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AnonymousFeedbackFormTargetProductEnum;
(function (AnonymousFeedbackFormTargetProductEnum) {
    AnonymousFeedbackFormTargetProductEnum["Web3CheckExtension"] = "WEB3_CHECK_EXTENSION";
})(AnonymousFeedbackFormTargetProductEnum = exports.AnonymousFeedbackFormTargetProductEnum || (exports.AnonymousFeedbackFormTargetProductEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiErrorStatusEnum;
(function (ApiErrorStatusEnum) {
    ApiErrorStatusEnum["_100Continue"] = "100 CONTINUE";
    ApiErrorStatusEnum["_101SwitchingProtocols"] = "101 SWITCHING_PROTOCOLS";
    ApiErrorStatusEnum["_102Processing"] = "102 PROCESSING";
    ApiErrorStatusEnum["_103Checkpoint"] = "103 CHECKPOINT";
    ApiErrorStatusEnum["_200Ok"] = "200 OK";
    ApiErrorStatusEnum["_201Created"] = "201 CREATED";
    ApiErrorStatusEnum["_202Accepted"] = "202 ACCEPTED";
    ApiErrorStatusEnum["_203NonAuthoritativeInformation"] = "203 NON_AUTHORITATIVE_INFORMATION";
    ApiErrorStatusEnum["_204NoContent"] = "204 NO_CONTENT";
    ApiErrorStatusEnum["_205ResetContent"] = "205 RESET_CONTENT";
    ApiErrorStatusEnum["_206PartialContent"] = "206 PARTIAL_CONTENT";
    ApiErrorStatusEnum["_207MultiStatus"] = "207 MULTI_STATUS";
    ApiErrorStatusEnum["_208AlreadyReported"] = "208 ALREADY_REPORTED";
    ApiErrorStatusEnum["_226ImUsed"] = "226 IM_USED";
    ApiErrorStatusEnum["_300MultipleChoices"] = "300 MULTIPLE_CHOICES";
    ApiErrorStatusEnum["_301MovedPermanently"] = "301 MOVED_PERMANENTLY";
    ApiErrorStatusEnum["_302Found"] = "302 FOUND";
    ApiErrorStatusEnum["_302MovedTemporarily"] = "302 MOVED_TEMPORARILY";
    ApiErrorStatusEnum["_303SeeOther"] = "303 SEE_OTHER";
    ApiErrorStatusEnum["_304NotModified"] = "304 NOT_MODIFIED";
    ApiErrorStatusEnum["_305UseProxy"] = "305 USE_PROXY";
    ApiErrorStatusEnum["_307TemporaryRedirect"] = "307 TEMPORARY_REDIRECT";
    ApiErrorStatusEnum["_308PermanentRedirect"] = "308 PERMANENT_REDIRECT";
    ApiErrorStatusEnum["_400BadRequest"] = "400 BAD_REQUEST";
    ApiErrorStatusEnum["_401Unauthorized"] = "401 UNAUTHORIZED";
    ApiErrorStatusEnum["_402PaymentRequired"] = "402 PAYMENT_REQUIRED";
    ApiErrorStatusEnum["_403Forbidden"] = "403 FORBIDDEN";
    ApiErrorStatusEnum["_404NotFound"] = "404 NOT_FOUND";
    ApiErrorStatusEnum["_405MethodNotAllowed"] = "405 METHOD_NOT_ALLOWED";
    ApiErrorStatusEnum["_406NotAcceptable"] = "406 NOT_ACCEPTABLE";
    ApiErrorStatusEnum["_407ProxyAuthenticationRequired"] = "407 PROXY_AUTHENTICATION_REQUIRED";
    ApiErrorStatusEnum["_408RequestTimeout"] = "408 REQUEST_TIMEOUT";
    ApiErrorStatusEnum["_409Conflict"] = "409 CONFLICT";
    ApiErrorStatusEnum["_410Gone"] = "410 GONE";
    ApiErrorStatusEnum["_411LengthRequired"] = "411 LENGTH_REQUIRED";
    ApiErrorStatusEnum["_412PreconditionFailed"] = "412 PRECONDITION_FAILED";
    ApiErrorStatusEnum["_413PayloadTooLarge"] = "413 PAYLOAD_TOO_LARGE";
    ApiErrorStatusEnum["_413RequestEntityTooLarge"] = "413 REQUEST_ENTITY_TOO_LARGE";
    ApiErrorStatusEnum["_414UriTooLong"] = "414 URI_TOO_LONG";
    ApiErrorStatusEnum["_414RequestUriTooLong"] = "414 REQUEST_URI_TOO_LONG";
    ApiErrorStatusEnum["_415UnsupportedMediaType"] = "415 UNSUPPORTED_MEDIA_TYPE";
    ApiErrorStatusEnum["_416RequestedRangeNotSatisfiable"] = "416 REQUESTED_RANGE_NOT_SATISFIABLE";
    ApiErrorStatusEnum["_417ExpectationFailed"] = "417 EXPECTATION_FAILED";
    ApiErrorStatusEnum["_418IAmATeapot"] = "418 I_AM_A_TEAPOT";
    ApiErrorStatusEnum["_419InsufficientSpaceOnResource"] = "419 INSUFFICIENT_SPACE_ON_RESOURCE";
    ApiErrorStatusEnum["_420MethodFailure"] = "420 METHOD_FAILURE";
    ApiErrorStatusEnum["_421DestinationLocked"] = "421 DESTINATION_LOCKED";
    ApiErrorStatusEnum["_422UnprocessableEntity"] = "422 UNPROCESSABLE_ENTITY";
    ApiErrorStatusEnum["_423Locked"] = "423 LOCKED";
    ApiErrorStatusEnum["_424FailedDependency"] = "424 FAILED_DEPENDENCY";
    ApiErrorStatusEnum["_425TooEarly"] = "425 TOO_EARLY";
    ApiErrorStatusEnum["_426UpgradeRequired"] = "426 UPGRADE_REQUIRED";
    ApiErrorStatusEnum["_428PreconditionRequired"] = "428 PRECONDITION_REQUIRED";
    ApiErrorStatusEnum["_429TooManyRequests"] = "429 TOO_MANY_REQUESTS";
    ApiErrorStatusEnum["_431RequestHeaderFieldsTooLarge"] = "431 REQUEST_HEADER_FIELDS_TOO_LARGE";
    ApiErrorStatusEnum["_451UnavailableForLegalReasons"] = "451 UNAVAILABLE_FOR_LEGAL_REASONS";
    ApiErrorStatusEnum["_500InternalServerError"] = "500 INTERNAL_SERVER_ERROR";
    ApiErrorStatusEnum["_501NotImplemented"] = "501 NOT_IMPLEMENTED";
    ApiErrorStatusEnum["_502BadGateway"] = "502 BAD_GATEWAY";
    ApiErrorStatusEnum["_503ServiceUnavailable"] = "503 SERVICE_UNAVAILABLE";
    ApiErrorStatusEnum["_504GatewayTimeout"] = "504 GATEWAY_TIMEOUT";
    ApiErrorStatusEnum["_505HttpVersionNotSupported"] = "505 HTTP_VERSION_NOT_SUPPORTED";
    ApiErrorStatusEnum["_506VariantAlsoNegotiates"] = "506 VARIANT_ALSO_NEGOTIATES";
    ApiErrorStatusEnum["_507InsufficientStorage"] = "507 INSUFFICIENT_STORAGE";
    ApiErrorStatusEnum["_508LoopDetected"] = "508 LOOP_DETECTED";
    ApiErrorStatusEnum["_509BandwidthLimitExceeded"] = "509 BANDWIDTH_LIMIT_EXCEEDED";
    ApiErrorStatusEnum["_510NotExtended"] = "510 NOT_EXTENDED";
    ApiErrorStatusEnum["_511NetworkAuthenticationRequired"] = "511 NETWORK_AUTHENTICATION_REQUIRED";
})(ApiErrorStatusEnum = exports.ApiErrorStatusEnum || (exports.ApiErrorStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApiErrorCode;
(function (ApiErrorCode) {
    ApiErrorCode["AccountNotFound"] = "ACCOUNT_NOT_FOUND";
    ApiErrorCode["UpdatePasswordFalure"] = "UPDATE_PASSWORD_FALURE";
    ApiErrorCode["RoleNotFound"] = "ROLE_NOT_FOUND";
    ApiErrorCode["AccountDisabled"] = "ACCOUNT_DISABLED";
    ApiErrorCode["AccountLocked"] = "ACCOUNT_LOCKED";
    ApiErrorCode["BadCredential"] = "BAD_CREDENTIAL";
    ApiErrorCode["InvalidRefreshToken"] = "INVALID_REFRESH_TOKEN";
    ApiErrorCode["InvalidAuthorizationCode"] = "INVALID_AUTHORIZATION_CODE";
    ApiErrorCode["AccountExisted"] = "ACCOUNT_EXISTED";
    ApiErrorCode["DuplicatedUserRegistration"] = "DUPLICATED_USER_REGISTRATION";
    ApiErrorCode["AddressNotFound"] = "ADDRESS_NOT_FOUND";
    ApiErrorCode["BlockNotFound"] = "BLOCK_NOT_FOUND";
    ApiErrorCode["TxNotFound"] = "TX_NOT_FOUND";
    ApiErrorCode["VoutNotFound"] = "VOUT_NOT_FOUND";
    ApiErrorCode["InvalidScript"] = "INVALID_SCRIPT";
    ApiErrorCode["InvalidGoogleInfo"] = "INVALID_GOOGLE_INFO";
    ApiErrorCode["AccountRoleNotFound"] = "ACCOUNT_ROLE_NOT_FOUND";
    ApiErrorCode["RoleNameDuplicated"] = "ROLE_NAME_DUPLICATED";
    ApiErrorCode["MobileNotProvided"] = "MOBILE_NOT_PROVIDED";
    ApiErrorCode["DuplicatedMobile"] = "DUPLICATED_MOBILE";
    ApiErrorCode["MobileAlreadyVerified"] = "MOBILE_ALREADY_VERIFIED";
    ApiErrorCode["InvalidVerificationCode"] = "INVALID_VERIFICATION_CODE";
    ApiErrorCode["BtcFlowJobNotFound"] = "BTC_FLOW_JOB_NOT_FOUND";
    ApiErrorCode["UpstreamJobNotDone"] = "UPSTREAM_JOB_NOT_DONE";
    ApiErrorCode["InconsistentLevel"] = "INCONSISTENT_LEVEL";
    ApiErrorCode["InconsistentAddress"] = "INCONSISTENT_ADDRESS";
    ApiErrorCode["BtcFlowAddressTagJobNotFound"] = "BTC_FLOW_ADDRESS_TAG_JOB_NOT_FOUND";
    ApiErrorCode["BtcFlowRiskJobNotFound"] = "BTC_FLOW_RISK_JOB_NOT_FOUND";
    ApiErrorCode["BtcFlowTxJobNotFound"] = "BTC_FLOW_TX_JOB_NOT_FOUND";
    ApiErrorCode["JobTimeout"] = "JOB_TIMEOUT";
    ApiErrorCode["BtcAddressScanPipelineNotFound"] = "BTC_ADDRESS_SCAN_PIPELINE_NOT_FOUND";
    ApiErrorCode["TimeRangeNotProvided"] = "TIME_RANGE_NOT_PROVIDED";
    ApiErrorCode["EthFlowJobNotFound"] = "ETH_FLOW_JOB_NOT_FOUND";
    ApiErrorCode["EthFlowAddressTagJobNotFound"] = "ETH_FLOW_ADDRESS_TAG_JOB_NOT_FOUND";
    ApiErrorCode["EthFlowRiskJobNotFound"] = "ETH_FLOW_RISK_JOB_NOT_FOUND";
    ApiErrorCode["EthAddressScanPipelineNotFound"] = "ETH_ADDRESS_SCAN_PIPELINE_NOT_FOUND";
    ApiErrorCode["AddressWithoutTx"] = "ADDRESS_WITHOUT_TX";
    ApiErrorCode["XrpFlowAddressTagJobNotFound"] = "XRP_FLOW_ADDRESS_TAG_JOB_NOT_FOUND";
    ApiErrorCode["XrpFlowJobNotFound"] = "XRP_FLOW_JOB_NOT_FOUND";
    ApiErrorCode["XrpFlowRiskJobNotFound"] = "XRP_FLOW_RISK_JOB_NOT_FOUND";
    ApiErrorCode["XrpAddressScanPipelineNotFound"] = "XRP_ADDRESS_SCAN_PIPELINE_NOT_FOUND";
    ApiErrorCode["UsageExceed"] = "USAGE_EXCEED";
    ApiErrorCode["EmailExisted"] = "EMAIL_EXISTED";
    ApiErrorCode["ZilAddressScanPipelineNotFound"] = "ZIL_ADDRESS_SCAN_PIPELINE_NOT_FOUND";
    ApiErrorCode["ZilFlowRiskJobNotFound"] = "ZIL_FLOW_RISK_JOB_NOT_FOUND";
    ApiErrorCode["ProjectNotFound"] = "PROJECT_NOT_FOUND";
    ApiErrorCode["ProjectMemberNotFound"] = "PROJECT_MEMBER_NOT_FOUND";
    ApiErrorCode["HolderGroupNotFound"] = "HOLDER_GROUP_NOT_FOUND";
    ApiErrorCode["BlobNotFound"] = "BLOB_NOT_FOUND";
    ApiErrorCode["AssetNotFound"] = "ASSET_NOT_FOUND";
    ApiErrorCode["AddressScanNotFound"] = "ADDRESS_SCAN_NOT_FOUND";
    ApiErrorCode["SearchNotFound"] = "SEARCH_NOT_FOUND";
    ApiErrorCode["InvalidWorkflowArgument"] = "INVALID_WORKFLOW_ARGUMENT";
    ApiErrorCode["InsufficientBalance"] = "INSUFFICIENT_BALANCE";
    ApiErrorCode["AddressScanBatchNotFound"] = "ADDRESS_SCAN_BATCH_NOT_FOUND";
    ApiErrorCode["ProjectAssetNotFound"] = "PROJECT_ASSET_NOT_FOUND";
    ApiErrorCode["ProjectOperationDisabled"] = "PROJECT_OPERATION_DISABLED";
    ApiErrorCode["ProjectAssetOperationDisabled"] = "PROJECT_ASSET_OPERATION_DISABLED";
    ApiErrorCode["KvNotFound"] = "KV_NOT_FOUND";
    ApiErrorCode["ExceedLimitation"] = "EXCEED_LIMITATION";
    ApiErrorCode["InvalidAddressScanStatus"] = "INVALID_ADDRESS_SCAN_STATUS";
    ApiErrorCode["InvalidFlowLabelingStatus"] = "INVALID_FLOW_LABELING_STATUS";
    ApiErrorCode["FlowLabelingNotFound"] = "FLOW_LABELING_NOT_FOUND";
    ApiErrorCode["DuplicatedAddressCase"] = "DUPLICATED_ADDRESS_CASE";
    ApiErrorCode["AddressCaseCommentNotFound"] = "ADDRESS_CASE_COMMENT_NOT_FOUND";
    ApiErrorCode["HolderAddressNotFound"] = "HOLDER_ADDRESS_NOT_FOUND";
    ApiErrorCode["HolderNotFound"] = "HOLDER_NOT_FOUND";
    ApiErrorCode["DuplicatedHolderAddress"] = "DUPLICATED_HOLDER_ADDRESS";
    ApiErrorCode["IncidentNotFound"] = "INCIDENT_NOT_FOUND";
    ApiErrorCode["IncidentAddressScanNotFound"] = "INCIDENT_ADDRESS_SCAN_NOT_FOUND";
    ApiErrorCode["DuplicatedIncidentAddressScan"] = "DUPLICATED_INCIDENT_ADDRESS_SCAN";
    ApiErrorCode["IncidentClusterNotFound"] = "INCIDENT_CLUSTER_NOT_FOUND";
    ApiErrorCode["AddressCaseNotFound"] = "ADDRESS_CASE_NOT_FOUND";
    ApiErrorCode["LabelNotFound"] = "LABEL_NOT_FOUND";
    ApiErrorCode["LabelCategoryNotFound"] = "LABEL_CATEGORY_NOT_FOUND";
    ApiErrorCode["ApiKeyNotFound"] = "API_KEY_NOT_FOUND";
    ApiErrorCode["Forbidden"] = "FORBIDDEN";
    ApiErrorCode["Unauthorized"] = "UNAUTHORIZED";
    ApiErrorCode["UnexpectedError"] = "UNEXPECTED_ERROR";
    ApiErrorCode["ChainNotFound"] = "CHAIN_NOT_FOUND";
    ApiErrorCode["InconsistentAddressScanAssetChain"] = "INCONSISTENT_ADDRESS_SCAN_ASSET_CHAIN";
    ApiErrorCode["InconsistentFlowLabelingAssetChain"] = "INCONSISTENT_FLOW_LABELING_ASSET_CHAIN";
    ApiErrorCode["InvalidAddressFormat"] = "INVALID_ADDRESS_FORMAT";
    ApiErrorCode["InsufficientQuota"] = "INSUFFICIENT_QUOTA";
    ApiErrorCode["QuotaUsageNotFound"] = "QUOTA_USAGE_NOT_FOUND";
    ApiErrorCode["PlanQuotaNotFound"] = "PLAN_QUOTA_NOT_FOUND";
    ApiErrorCode["PlanPermissionNotFound"] = "PLAN_PERMISSION_NOT_FOUND";
    ApiErrorCode["EntityNotFound"] = "ENTITY_NOT_FOUND";
    ApiErrorCode["RecaptchaVerifyFailed"] = "RECAPTCHA_VERIFY_FAILED";
    ApiErrorCode["RuleNotFound"] = "RULE_NOT_FOUND";
    ApiErrorCode["ReporterEmailNotProvided"] = "REPORTER_EMAIL_NOT_PROVIDED";
    ApiErrorCode["ReporterNameNotProvided"] = "REPORTER_NAME_NOT_PROVIDED";
    ApiErrorCode["InvalidUrl"] = "INVALID_URL";
    ApiErrorCode["InvliadDomain"] = "INVLIAD_DOMAIN";
})(ApiErrorCode = exports.ApiErrorCode || (exports.ApiErrorCode = {}));
/**
    * @export
    * @enum {string}
    */
var ChainDtoAddressFormatEnum;
(function (ChainDtoAddressFormatEnum) {
    ChainDtoAddressFormatEnum["None"] = "NONE";
    ChainDtoAddressFormatEnum["Upper"] = "UPPER";
    ChainDtoAddressFormatEnum["Lower"] = "LOWER";
})(ChainDtoAddressFormatEnum = exports.ChainDtoAddressFormatEnum || (exports.ChainDtoAddressFormatEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FlowLabelingCreationMethodEnum;
(function (FlowLabelingCreationMethodEnum) {
    FlowLabelingCreationMethodEnum["Taint"] = "TAINT";
    FlowLabelingCreationMethodEnum["Max"] = "MAX";
})(FlowLabelingCreationMethodEnum = exports.FlowLabelingCreationMethodEnum || (exports.FlowLabelingCreationMethodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FlowLabelingDtoStatusEnum;
(function (FlowLabelingDtoStatusEnum) {
    FlowLabelingDtoStatusEnum["Pending"] = "PENDING";
    FlowLabelingDtoStatusEnum["Submitted"] = "SUBMITTED";
    FlowLabelingDtoStatusEnum["Running"] = "RUNNING";
    FlowLabelingDtoStatusEnum["Completed"] = "COMPLETED";
    FlowLabelingDtoStatusEnum["Failed"] = "FAILED";
})(FlowLabelingDtoStatusEnum = exports.FlowLabelingDtoStatusEnum || (exports.FlowLabelingDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FlowLabelingDtoMethodEnum;
(function (FlowLabelingDtoMethodEnum) {
    FlowLabelingDtoMethodEnum["Taint"] = "TAINT";
    FlowLabelingDtoMethodEnum["Max"] = "MAX";
})(FlowLabelingDtoMethodEnum = exports.FlowLabelingDtoMethodEnum || (exports.FlowLabelingDtoMethodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var HolderCreationLevelEnum;
(function (HolderCreationLevelEnum) {
    HolderCreationLevelEnum["High"] = "HIGH";
    HolderCreationLevelEnum["Medium"] = "MEDIUM";
    HolderCreationLevelEnum["Low"] = "LOW";
})(HolderCreationLevelEnum = exports.HolderCreationLevelEnum || (exports.HolderCreationLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var HolderDtoLevelEnum;
(function (HolderDtoLevelEnum) {
    HolderDtoLevelEnum["High"] = "HIGH";
    HolderDtoLevelEnum["Medium"] = "MEDIUM";
    HolderDtoLevelEnum["Low"] = "LOW";
})(HolderDtoLevelEnum = exports.HolderDtoLevelEnum || (exports.HolderDtoLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var HolderLevelCountLevelEnum;
(function (HolderLevelCountLevelEnum) {
    HolderLevelCountLevelEnum["High"] = "HIGH";
    HolderLevelCountLevelEnum["Medium"] = "MEDIUM";
    HolderLevelCountLevelEnum["Low"] = "LOW";
})(HolderLevelCountLevelEnum = exports.HolderLevelCountLevelEnum || (exports.HolderLevelCountLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var HolderUpdatesLevelEnum;
(function (HolderUpdatesLevelEnum) {
    HolderUpdatesLevelEnum["High"] = "HIGH";
    HolderUpdatesLevelEnum["Medium"] = "MEDIUM";
    HolderUpdatesLevelEnum["Low"] = "LOW";
})(HolderUpdatesLevelEnum = exports.HolderUpdatesLevelEnum || (exports.HolderUpdatesLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var IncidentDtoStatusEnum;
(function (IncidentDtoStatusEnum) {
    IncidentDtoStatusEnum["Open"] = "OPEN";
    IncidentDtoStatusEnum["InReview"] = "IN_REVIEW";
    IncidentDtoStatusEnum["Closed"] = "CLOSED";
})(IncidentDtoStatusEnum = exports.IncidentDtoStatusEnum || (exports.IncidentDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var IncidentStatusCountStatusEnum;
(function (IncidentStatusCountStatusEnum) {
    IncidentStatusCountStatusEnum["Open"] = "OPEN";
    IncidentStatusCountStatusEnum["InReview"] = "IN_REVIEW";
    IncidentStatusCountStatusEnum["Closed"] = "CLOSED";
})(IncidentStatusCountStatusEnum = exports.IncidentStatusCountStatusEnum || (exports.IncidentStatusCountStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ProjectMemberDtoAccessLevelEnum;
(function (ProjectMemberDtoAccessLevelEnum) {
    ProjectMemberDtoAccessLevelEnum["Owner"] = "OWNER";
    ProjectMemberDtoAccessLevelEnum["Viewer"] = "VIEWER";
})(ProjectMemberDtoAccessLevelEnum = exports.ProjectMemberDtoAccessLevelEnum || (exports.ProjectMemberDtoAccessLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ReportTicketCreationReportTypeEnum;
(function (ReportTicketCreationReportTypeEnum) {
    ReportTicketCreationReportTypeEnum["Fp"] = "FP";
    ReportTicketCreationReportTypeEnum["Fn"] = "FN";
})(ReportTicketCreationReportTypeEnum = exports.ReportTicketCreationReportTypeEnum || (exports.ReportTicketCreationReportTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ReportTicketCreationIssueTypeEnum;
(function (ReportTicketCreationIssueTypeEnum) {
    ReportTicketCreationIssueTypeEnum["Phishing"] = "PHISHING";
    ReportTicketCreationIssueTypeEnum["Blackmail"] = "BLACKMAIL";
    ReportTicketCreationIssueTypeEnum["Sextortion"] = "SEXTORTION";
    ReportTicketCreationIssueTypeEnum["Ransomware"] = "RANSOMWARE";
    ReportTicketCreationIssueTypeEnum["Impersonation"] = "IMPERSONATION";
    ReportTicketCreationIssueTypeEnum["InvestmentScam"] = "INVESTMENT_SCAM";
    ReportTicketCreationIssueTypeEnum["RomanceScam"] = "ROMANCE_SCAM";
    ReportTicketCreationIssueTypeEnum["ContractExploit"] = "CONTRACT_EXPLOIT";
    ReportTicketCreationIssueTypeEnum["FakeGiveaway"] = "FAKE_GIVEAWAY";
    ReportTicketCreationIssueTypeEnum["Other"] = "OTHER";
})(ReportTicketCreationIssueTypeEnum = exports.ReportTicketCreationIssueTypeEnum || (exports.ReportTicketCreationIssueTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ReportTicketDtoReportTypeEnum;
(function (ReportTicketDtoReportTypeEnum) {
    ReportTicketDtoReportTypeEnum["Fp"] = "FP";
    ReportTicketDtoReportTypeEnum["Fn"] = "FN";
})(ReportTicketDtoReportTypeEnum = exports.ReportTicketDtoReportTypeEnum || (exports.ReportTicketDtoReportTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ReportTicketDtoIssueTypeEnum;
(function (ReportTicketDtoIssueTypeEnum) {
    ReportTicketDtoIssueTypeEnum["Phishing"] = "PHISHING";
    ReportTicketDtoIssueTypeEnum["Blackmail"] = "BLACKMAIL";
    ReportTicketDtoIssueTypeEnum["Sextortion"] = "SEXTORTION";
    ReportTicketDtoIssueTypeEnum["Ransomware"] = "RANSOMWARE";
    ReportTicketDtoIssueTypeEnum["Impersonation"] = "IMPERSONATION";
    ReportTicketDtoIssueTypeEnum["InvestmentScam"] = "INVESTMENT_SCAM";
    ReportTicketDtoIssueTypeEnum["RomanceScam"] = "ROMANCE_SCAM";
    ReportTicketDtoIssueTypeEnum["ContractExploit"] = "CONTRACT_EXPLOIT";
    ReportTicketDtoIssueTypeEnum["FakeGiveaway"] = "FAKE_GIVEAWAY";
    ReportTicketDtoIssueTypeEnum["Other"] = "OTHER";
})(ReportTicketDtoIssueTypeEnum = exports.ReportTicketDtoIssueTypeEnum || (exports.ReportTicketDtoIssueTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ResultEntryTypeEnum;
(function (ResultEntryTypeEnum) {
    ResultEntryTypeEnum["Account"] = "ACCOUNT";
    ResultEntryTypeEnum["Dapp"] = "DAPP";
    ResultEntryTypeEnum["FungibleToken"] = "FUNGIBLE_TOKEN";
    ResultEntryTypeEnum["NonFungibleToken"] = "NON_FUNGIBLE_TOKEN";
    ResultEntryTypeEnum["Url"] = "URL";
    ResultEntryTypeEnum["Domain"] = "DOMAIN";
    ResultEntryTypeEnum["Ip"] = "IP";
})(ResultEntryTypeEnum = exports.ResultEntryTypeEnum || (exports.ResultEntryTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TxDtoTypeEnum;
(function (TxDtoTypeEnum) {
    TxDtoTypeEnum["TopUp"] = "TOP_UP";
    TxDtoTypeEnum["ChargeAddressScan"] = "CHARGE_ADDRESS_SCAN";
    TxDtoTypeEnum["ChargeFlowLabeling"] = "CHARGE_FLOW_LABELING";
})(TxDtoTypeEnum = exports.TxDtoTypeEnum || (exports.TxDtoTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserFeedbackFormTargetProductEnum;
(function (UserFeedbackFormTargetProductEnum) {
    UserFeedbackFormTargetProductEnum["Web3CheckExtension"] = "WEB3_CHECK_EXTENSION";
})(UserFeedbackFormTargetProductEnum = exports.UserFeedbackFormTargetProductEnum || (exports.UserFeedbackFormTargetProductEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WitnessDtoCategoryEnum;
(function (WitnessDtoCategoryEnum) {
    WitnessDtoCategoryEnum["Send"] = "SEND";
    WitnessDtoCategoryEnum["Receive"] = "RECEIVE";
    WitnessDtoCategoryEnum["Predict"] = "PREDICT";
    WitnessDtoCategoryEnum["Other"] = "OTHER";
})(WitnessDtoCategoryEnum = exports.WitnessDtoCategoryEnum || (exports.WitnessDtoCategoryEnum = {}));
/**
 * AccountApi - axios parameter creator
 * @export
 */
exports.AccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAccount', 'id', id);
                            localVarPath = "/api/account/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns current plan and quota usage state
         * @summary Get plan and quota information
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPlan: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAccountPlan', 'id', id);
                            localVarPath = "/api/account/{id}/plan"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns primary API Key of the Account
         * @summary Get primary API key
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPrimaryApiKey: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAccountPrimaryApiKey', 'id', id);
                            localVarPath = "/api/account/{id}/primary-api-key"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of accessible projects by Account ID
         * @summary Get owned projects
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountProject: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAccountProject', 'id', id);
                            localVarPath = "/api/account/{id}/project"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns information about current login account
         * @summary Get current login account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/account/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUpgradePlan: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('requestUpgradePlan', 'id', id);
                            localVarPath = "/api/account/{id}/request-upgrade"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AccountApi - functional programming interface
 * @export
 */
exports.AccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AccountApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccount(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns current plan and quota usage state
         * @summary Get plan and quota information
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPlan: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountPlan(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns primary API Key of the Account
         * @summary Get primary API key
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPrimaryApiKey: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountPrimaryApiKey(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of accessible projects by Account ID
         * @summary Get owned projects
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountProject: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountProject(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns information about current login account
         * @summary Get current login account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMe(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUpgradePlan: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestUpgradePlan(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AccountApi - factory interface
 * @export
 */
exports.AccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AccountApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: function (id, options) {
            return localVarFp.getAccount(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns current plan and quota usage state
         * @summary Get plan and quota information
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPlan: function (id, options) {
            return localVarFp.getAccountPlan(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns primary API Key of the Account
         * @summary Get primary API key
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPrimaryApiKey: function (id, options) {
            return localVarFp.getAccountPrimaryApiKey(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of accessible projects by Account ID
         * @summary Get owned projects
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountProject: function (id, options) {
            return localVarFp.getAccountProject(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns information about current login account
         * @summary Get current login account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: function (options) {
            return localVarFp.getMe(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUpgradePlan: function (id, options) {
            return localVarFp.requestUpgradePlan(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
var AccountApi = /** @class */ (function (_super) {
    __extends(AccountApi, _super);
    function AccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccount = function (id, options) {
        var _this = this;
        return exports.AccountApiFp(this.configuration).getAccount(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns current plan and quota usage state
     * @summary Get plan and quota information
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccountPlan = function (id, options) {
        var _this = this;
        return exports.AccountApiFp(this.configuration).getAccountPlan(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns primary API Key of the Account
     * @summary Get primary API key
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccountPrimaryApiKey = function (id, options) {
        var _this = this;
        return exports.AccountApiFp(this.configuration).getAccountPrimaryApiKey(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of accessible projects by Account ID
     * @summary Get owned projects
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccountProject = function (id, options) {
        var _this = this;
        return exports.AccountApiFp(this.configuration).getAccountProject(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns information about current login account
     * @summary Get current login account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getMe = function (options) {
        var _this = this;
        return exports.AccountApiFp(this.configuration).getMe(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.requestUpgradePlan = function (id, options) {
        var _this = this;
        return exports.AccountApiFp(this.configuration).requestUpgradePlan(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountApi;
}(base_1.BaseAPI));
exports.AccountApi = AccountApi;
/**
 * AddressApi - axios parameter creator
 * @export
 */
exports.AddressApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AddressList} addressList
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAddressDetails: function (addressList, projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressList' is not null or undefined
                            common_1.assertParamExists('listAddressDetails', 'addressList', addressList);
                            localVarPath = "/api/address";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addressList, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AddressApi - functional programming interface
 * @export
 */
exports.AddressApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AddressApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AddressList} addressList
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAddressDetails: function (addressList, projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listAddressDetails(addressList, projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AddressApi - factory interface
 * @export
 */
exports.AddressApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AddressApiFp(configuration);
    return {
        /**
         *
         * @param {AddressList} addressList
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAddressDetails: function (addressList, projectId, options) {
            return localVarFp.listAddressDetails(addressList, projectId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
var AddressApi = /** @class */ (function (_super) {
    __extends(AddressApi, _super);
    function AddressApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AddressList} addressList
     * @param {string} [projectId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.listAddressDetails = function (addressList, projectId, options) {
        var _this = this;
        return exports.AddressApiFp(this.configuration).listAddressDetails(addressList, projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressApi;
}(base_1.BaseAPI));
exports.AddressApi = AddressApi;
/**
 * AddressCaseApi - axios parameter creator
 * @export
 */
exports.AddressCaseApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AddressCaseCreation} addressCaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressCase: function (addressCaseCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressCaseCreation' is not null or undefined
                            common_1.assertParamExists('createAddressCase', 'addressCaseCreation', addressCaseCreation);
                            localVarPath = "/api/address-case";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addressCaseCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressCase: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAddressCase', 'id', id);
                            localVarPath = "/api/address-case/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAddressCaseComment: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listAddressCaseComment', 'id', id);
                            localVarPath = "/api/address-case/{id}/comment"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAddressCaseLog: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listAddressCaseLog', 'id', id);
                            localVarPath = "/api/address-case/{id}/log"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressCase: function (page, size, projectId, chainId, address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/address-case";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (address !== undefined) {
                                localVarQueryParameter['address'] = address;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {'HIGH' | 'MEDIUM' | 'LOW'} level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAddressCaseLevel: function (id, level, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('patchAddressCaseLevel', 'id', id);
                            // verify required parameter 'level' is not null or undefined
                            common_1.assertParamExists('patchAddressCaseLevel', 'level', level);
                            localVarPath = "/api/address-case/{id}/level/{level}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (level !== undefined) {
                                localVarQueryParameter['level'] = level;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {'OPEN' | 'IN_REVIEW' | 'CLOSED'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAddressCaseStatus: function (id, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('patchAddressCaseStatus', 'id', id);
                            // verify required parameter 'status' is not null or undefined
                            common_1.assertParamExists('patchAddressCaseStatus', 'status', status);
                            localVarPath = "/api/address-case/{id}/status/{status}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AddressCaseApi - functional programming interface
 * @export
 */
exports.AddressCaseApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AddressCaseApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AddressCaseCreation} addressCaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressCase: function (addressCaseCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAddressCase(addressCaseCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressCase: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddressCase(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAddressCaseComment: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listAddressCaseComment(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAddressCaseLog: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listAddressCaseLog(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressCase: function (page, size, projectId, chainId, address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateAddressCase(page, size, projectId, chainId, address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {'HIGH' | 'MEDIUM' | 'LOW'} level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAddressCaseLevel: function (id, level, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchAddressCaseLevel(id, level, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {'OPEN' | 'IN_REVIEW' | 'CLOSED'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAddressCaseStatus: function (id, status, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchAddressCaseStatus(id, status, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AddressCaseApi - factory interface
 * @export
 */
exports.AddressCaseApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AddressCaseApiFp(configuration);
    return {
        /**
         *
         * @param {AddressCaseCreation} addressCaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressCase: function (addressCaseCreation, options) {
            return localVarFp.createAddressCase(addressCaseCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressCase: function (id, options) {
            return localVarFp.getAddressCase(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAddressCaseComment: function (id, options) {
            return localVarFp.listAddressCaseComment(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAddressCaseLog: function (id, options) {
            return localVarFp.listAddressCaseLog(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressCase: function (page, size, projectId, chainId, address, options) {
            return localVarFp.paginateAddressCase(page, size, projectId, chainId, address, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {'HIGH' | 'MEDIUM' | 'LOW'} level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAddressCaseLevel: function (id, level, options) {
            return localVarFp.patchAddressCaseLevel(id, level, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {'OPEN' | 'IN_REVIEW' | 'CLOSED'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAddressCaseStatus: function (id, status, options) {
            return localVarFp.patchAddressCaseStatus(id, status, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AddressCaseApi - object-oriented interface
 * @export
 * @class AddressCaseApi
 * @extends {BaseAPI}
 */
var AddressCaseApi = /** @class */ (function (_super) {
    __extends(AddressCaseApi, _super);
    function AddressCaseApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AddressCaseCreation} addressCaseCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseApi
     */
    AddressCaseApi.prototype.createAddressCase = function (addressCaseCreation, options) {
        var _this = this;
        return exports.AddressCaseApiFp(this.configuration).createAddressCase(addressCaseCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseApi
     */
    AddressCaseApi.prototype.getAddressCase = function (id, options) {
        var _this = this;
        return exports.AddressCaseApiFp(this.configuration).getAddressCase(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseApi
     */
    AddressCaseApi.prototype.listAddressCaseComment = function (id, options) {
        var _this = this;
        return exports.AddressCaseApiFp(this.configuration).listAddressCaseComment(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseApi
     */
    AddressCaseApi.prototype.listAddressCaseLog = function (id, options) {
        var _this = this;
        return exports.AddressCaseApiFp(this.configuration).listAddressCaseLog(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [projectId]
     * @param {string} [chainId]
     * @param {string} [address]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseApi
     */
    AddressCaseApi.prototype.paginateAddressCase = function (page, size, projectId, chainId, address, options) {
        var _this = this;
        return exports.AddressCaseApiFp(this.configuration).paginateAddressCase(page, size, projectId, chainId, address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {'HIGH' | 'MEDIUM' | 'LOW'} level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseApi
     */
    AddressCaseApi.prototype.patchAddressCaseLevel = function (id, level, options) {
        var _this = this;
        return exports.AddressCaseApiFp(this.configuration).patchAddressCaseLevel(id, level, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {'OPEN' | 'IN_REVIEW' | 'CLOSED'} status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseApi
     */
    AddressCaseApi.prototype.patchAddressCaseStatus = function (id, status, options) {
        var _this = this;
        return exports.AddressCaseApiFp(this.configuration).patchAddressCaseStatus(id, status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressCaseApi;
}(base_1.BaseAPI));
exports.AddressCaseApi = AddressCaseApi;
/**
 * AddressCaseCommentApi - axios parameter creator
 * @export
 */
exports.AddressCaseCommentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AddressCaseCommentCreation} addressCaseCommentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressCaseComment: function (addressCaseCommentCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressCaseCommentCreation' is not null or undefined
                            common_1.assertParamExists('createAddressCaseComment', 'addressCaseCommentCreation', addressCaseCommentCreation);
                            localVarPath = "/api/address-case-comment";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addressCaseCommentCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddressCaseComment: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteAddressCaseComment', 'id', id);
                            localVarPath = "/api/address-case-comment/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {AddressCaseCommentUpdates} addressCaseCommentUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyAddressCase: function (id, addressCaseCommentUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('modifyAddressCase', 'id', id);
                            // verify required parameter 'addressCaseCommentUpdates' is not null or undefined
                            common_1.assertParamExists('modifyAddressCase', 'addressCaseCommentUpdates', addressCaseCommentUpdates);
                            localVarPath = "/api/address-case-comment/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addressCaseCommentUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AddressCaseCommentApi - functional programming interface
 * @export
 */
exports.AddressCaseCommentApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AddressCaseCommentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AddressCaseCommentCreation} addressCaseCommentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressCaseComment: function (addressCaseCommentCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAddressCaseComment(addressCaseCommentCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddressCaseComment: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAddressCaseComment(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {AddressCaseCommentUpdates} addressCaseCommentUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyAddressCase: function (id, addressCaseCommentUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.modifyAddressCase(id, addressCaseCommentUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AddressCaseCommentApi - factory interface
 * @export
 */
exports.AddressCaseCommentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AddressCaseCommentApiFp(configuration);
    return {
        /**
         *
         * @param {AddressCaseCommentCreation} addressCaseCommentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressCaseComment: function (addressCaseCommentCreation, options) {
            return localVarFp.createAddressCaseComment(addressCaseCommentCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddressCaseComment: function (id, options) {
            return localVarFp.deleteAddressCaseComment(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {AddressCaseCommentUpdates} addressCaseCommentUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyAddressCase: function (id, addressCaseCommentUpdates, options) {
            return localVarFp.modifyAddressCase(id, addressCaseCommentUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AddressCaseCommentApi - object-oriented interface
 * @export
 * @class AddressCaseCommentApi
 * @extends {BaseAPI}
 */
var AddressCaseCommentApi = /** @class */ (function (_super) {
    __extends(AddressCaseCommentApi, _super);
    function AddressCaseCommentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AddressCaseCommentCreation} addressCaseCommentCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseCommentApi
     */
    AddressCaseCommentApi.prototype.createAddressCaseComment = function (addressCaseCommentCreation, options) {
        var _this = this;
        return exports.AddressCaseCommentApiFp(this.configuration).createAddressCaseComment(addressCaseCommentCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseCommentApi
     */
    AddressCaseCommentApi.prototype.deleteAddressCaseComment = function (id, options) {
        var _this = this;
        return exports.AddressCaseCommentApiFp(this.configuration).deleteAddressCaseComment(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {AddressCaseCommentUpdates} addressCaseCommentUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressCaseCommentApi
     */
    AddressCaseCommentApi.prototype.modifyAddressCase = function (id, addressCaseCommentUpdates, options) {
        var _this = this;
        return exports.AddressCaseCommentApiFp(this.configuration).modifyAddressCase(id, addressCaseCommentUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressCaseCommentApi;
}(base_1.BaseAPI));
exports.AddressCaseCommentApi = AddressCaseCommentApi;
/**
 * AddressLabelApi - axios parameter creator
 * @export
 */
exports.AddressLabelApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns all created address label mappings
         * @summary Create new address label mappings
         * @param {AddressLabelBulkCreation} addressLabelBulkCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateAddressLabels: function (addressLabelBulkCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressLabelBulkCreation' is not null or undefined
                            common_1.assertParamExists('bulkCreateAddressLabels', 'addressLabelBulkCreation', addressLabelBulkCreation);
                            localVarPath = "/api/address-label/bulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addressLabelBulkCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete address label mappings
         * @param {AddressLabelBulkDeletion} addressLabelBulkDeletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateAddressLabels1: function (addressLabelBulkDeletion, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressLabelBulkDeletion' is not null or undefined
                            common_1.assertParamExists('bulkCreateAddressLabels1', 'addressLabelBulkDeletion', addressLabelBulkDeletion);
                            localVarPath = "/api/address-label/bulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addressLabelBulkDeletion, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all labels of a specific address.
         * @summary Search label by address
         * @param {string} address Address
         * @param {string} [chainId] Chain ID
         * @param {string} [projectId] Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLabels1: function (address, chainId, projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'address' is not null or undefined
                            common_1.assertParamExists('searchLabels1', 'address', address);
                            localVarPath = "/api/address-label";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (address !== undefined) {
                                localVarQueryParameter['address'] = address;
                            }
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AddressLabelApi - functional programming interface
 * @export
 */
exports.AddressLabelApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AddressLabelApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns all created address label mappings
         * @summary Create new address label mappings
         * @param {AddressLabelBulkCreation} addressLabelBulkCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateAddressLabels: function (addressLabelBulkCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkCreateAddressLabels(addressLabelBulkCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete address label mappings
         * @param {AddressLabelBulkDeletion} addressLabelBulkDeletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateAddressLabels1: function (addressLabelBulkDeletion, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkCreateAddressLabels1(addressLabelBulkDeletion, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all labels of a specific address.
         * @summary Search label by address
         * @param {string} address Address
         * @param {string} [chainId] Chain ID
         * @param {string} [projectId] Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLabels1: function (address, chainId, projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchLabels1(address, chainId, projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AddressLabelApi - factory interface
 * @export
 */
exports.AddressLabelApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AddressLabelApiFp(configuration);
    return {
        /**
         * Returns all created address label mappings
         * @summary Create new address label mappings
         * @param {AddressLabelBulkCreation} addressLabelBulkCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateAddressLabels: function (addressLabelBulkCreation, options) {
            return localVarFp.bulkCreateAddressLabels(addressLabelBulkCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete address label mappings
         * @param {AddressLabelBulkDeletion} addressLabelBulkDeletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateAddressLabels1: function (addressLabelBulkDeletion, options) {
            return localVarFp.bulkCreateAddressLabels1(addressLabelBulkDeletion, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all labels of a specific address.
         * @summary Search label by address
         * @param {string} address Address
         * @param {string} [chainId] Chain ID
         * @param {string} [projectId] Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLabels1: function (address, chainId, projectId, options) {
            return localVarFp.searchLabels1(address, chainId, projectId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AddressLabelApi - object-oriented interface
 * @export
 * @class AddressLabelApi
 * @extends {BaseAPI}
 */
var AddressLabelApi = /** @class */ (function (_super) {
    __extends(AddressLabelApi, _super);
    function AddressLabelApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns all created address label mappings
     * @summary Create new address label mappings
     * @param {AddressLabelBulkCreation} addressLabelBulkCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressLabelApi
     */
    AddressLabelApi.prototype.bulkCreateAddressLabels = function (addressLabelBulkCreation, options) {
        var _this = this;
        return exports.AddressLabelApiFp(this.configuration).bulkCreateAddressLabels(addressLabelBulkCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete address label mappings
     * @param {AddressLabelBulkDeletion} addressLabelBulkDeletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressLabelApi
     */
    AddressLabelApi.prototype.bulkCreateAddressLabels1 = function (addressLabelBulkDeletion, options) {
        var _this = this;
        return exports.AddressLabelApiFp(this.configuration).bulkCreateAddressLabels1(addressLabelBulkDeletion, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all labels of a specific address.
     * @summary Search label by address
     * @param {string} address Address
     * @param {string} [chainId] Chain ID
     * @param {string} [projectId] Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressLabelApi
     */
    AddressLabelApi.prototype.searchLabels1 = function (address, chainId, projectId, options) {
        var _this = this;
        return exports.AddressLabelApiFp(this.configuration).searchLabels1(address, chainId, projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressLabelApi;
}(base_1.BaseAPI));
exports.AddressLabelApi = AddressLabelApi;
/**
 * AddressScanApi - axios parameter creator
 * @export
 */
exports.AddressScanApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create an address scan
         * @param {AddressScanCreation} addressScanCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressScan: function (addressScanCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressScanCreation' is not null or undefined
                            common_1.assertParamExists('createAddressScan', 'addressScanCreation', addressScanCreation);
                            localVarPath = "/api/address-scan";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addressScanCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns an address scan record by ID.
         * @summary Get Address Scan by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScan: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAddressScan', 'id', id);
                            localVarPath = "/api/address-scan/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the Clustered payment flows graph of an address scan. The paginated nodes (clusters) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Cluster graph
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanClusterGraph: function (id, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAddressScanClusterGraph', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('getAddressScanClusterGraph', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('getAddressScanClusterGraph', 'size', size);
                            localVarPath = "/api/address-scan/{id}/cluster-graph"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the Clustered payment flows graph of an address scan. The returned nodes (clusters) and edges (transactions) will only consist of the neighbor cluster of the provided `clusterIds` list. The paginated nodes (clusters) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Cluster graph (Neighbor)
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {Array<string>} clusterIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanClusterGraphNeighbor: function (id, page, size, clusterIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAddressScanClusterGraphNeighbor', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('getAddressScanClusterGraphNeighbor', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('getAddressScanClusterGraphNeighbor', 'size', size);
                            // verify required parameter 'clusterIds' is not null or undefined
                            common_1.assertParamExists('getAddressScanClusterGraphNeighbor', 'clusterIds', clusterIds);
                            localVarPath = "/api/address-scan/{id}/cluster-graph/neighbor"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (clusterIds) {
                                localVarQueryParameter['clusterIds'] = clusterIds;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the Payment flows graph of an address scan. The paginated nodes (addresses) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Payment flow graph
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanFlowGraph: function (id, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAddressScanFlowGraph', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('getAddressScanFlowGraph', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('getAddressScanFlowGraph', 'size', size);
                            localVarPath = "/api/address-scan/{id}/flow-graph"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the Payment flows graph of an address scan. The returned nodes (address) and edges (transactions) will only consist of the neighbor address of the provided `addresses` list. The paginated nodes (addresses) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Payment flow graph (Neighbor)
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {Array<string>} addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanFlowGraphNeibor: function (id, page, size, addresses, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAddressScanFlowGraphNeibor', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('getAddressScanFlowGraphNeibor', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('getAddressScanFlowGraphNeibor', 'size', size);
                            // verify required parameter 'addresses' is not null or undefined
                            common_1.assertParamExists('getAddressScanFlowGraphNeibor', 'addresses', addresses);
                            localVarPath = "/api/address-scan/{id}/flow-graph/neibor"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (addresses) {
                                localVarQueryParameter['addresses'] = addresses;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the forward and backward labels distribution of an address scanning.
         * @summary Get scanning result: Label distribution
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanLabelSunburst: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAddressScanLabelSunburst', 'id', id);
                            localVarPath = "/api/address-scan/{id}/label-sunburst"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a page of address scan history.
         * @summary Find address scan history
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [batchId]
         * @param {string} [chainId]
         * @param {string} [assetId]
         * @param {string} [address]
         * @param {string} [incidentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressScan: function (page, size, projectId, batchId, chainId, assetId, address, incidentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/address-scan";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            if (batchId !== undefined) {
                                localVarQueryParameter['batchId'] = batchId;
                            }
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (assetId !== undefined) {
                                localVarQueryParameter['assetId'] = assetId;
                            }
                            if (address !== undefined) {
                                localVarQueryParameter['address'] = address;
                            }
                            if (incidentId !== undefined) {
                                localVarQueryParameter['incidentId'] = incidentId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the issue list of an address scan.
         * @summary Get scanning result: Issue list
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {'SEND' | 'RECEIVE' | 'PREDICT' | 'OTHER'} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressScanWitness: function (id, page, size, category, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('paginateAddressScanWitness', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('paginateAddressScanWitness', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('paginateAddressScanWitness', 'size', size);
                            localVarPath = "/api/address-scan/{id}/witness"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (category !== undefined) {
                                localVarQueryParameter['category'] = category;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AddressScanApi - functional programming interface
 * @export
 */
exports.AddressScanApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AddressScanApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create an address scan
         * @param {AddressScanCreation} addressScanCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressScan: function (addressScanCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAddressScan(addressScanCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns an address scan record by ID.
         * @summary Get Address Scan by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScan: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddressScan(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the Clustered payment flows graph of an address scan. The paginated nodes (clusters) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Cluster graph
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanClusterGraph: function (id, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddressScanClusterGraph(id, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the Clustered payment flows graph of an address scan. The returned nodes (clusters) and edges (transactions) will only consist of the neighbor cluster of the provided `clusterIds` list. The paginated nodes (clusters) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Cluster graph (Neighbor)
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {Array<string>} clusterIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanClusterGraphNeighbor: function (id, page, size, clusterIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddressScanClusterGraphNeighbor(id, page, size, clusterIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the Payment flows graph of an address scan. The paginated nodes (addresses) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Payment flow graph
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanFlowGraph: function (id, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddressScanFlowGraph(id, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the Payment flows graph of an address scan. The returned nodes (address) and edges (transactions) will only consist of the neighbor address of the provided `addresses` list. The paginated nodes (addresses) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Payment flow graph (Neighbor)
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {Array<string>} addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanFlowGraphNeibor: function (id, page, size, addresses, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddressScanFlowGraphNeibor(id, page, size, addresses, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the forward and backward labels distribution of an address scanning.
         * @summary Get scanning result: Label distribution
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanLabelSunburst: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddressScanLabelSunburst(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a page of address scan history.
         * @summary Find address scan history
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [batchId]
         * @param {string} [chainId]
         * @param {string} [assetId]
         * @param {string} [address]
         * @param {string} [incidentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressScan: function (page, size, projectId, batchId, chainId, assetId, address, incidentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateAddressScan(page, size, projectId, batchId, chainId, assetId, address, incidentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the issue list of an address scan.
         * @summary Get scanning result: Issue list
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {'SEND' | 'RECEIVE' | 'PREDICT' | 'OTHER'} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressScanWitness: function (id, page, size, category, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateAddressScanWitness(id, page, size, category, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AddressScanApi - factory interface
 * @export
 */
exports.AddressScanApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AddressScanApiFp(configuration);
    return {
        /**
         *
         * @summary Create an address scan
         * @param {AddressScanCreation} addressScanCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressScan: function (addressScanCreation, options) {
            return localVarFp.createAddressScan(addressScanCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns an address scan record by ID.
         * @summary Get Address Scan by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScan: function (id, options) {
            return localVarFp.getAddressScan(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the Clustered payment flows graph of an address scan. The paginated nodes (clusters) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Cluster graph
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanClusterGraph: function (id, page, size, options) {
            return localVarFp.getAddressScanClusterGraph(id, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the Clustered payment flows graph of an address scan. The returned nodes (clusters) and edges (transactions) will only consist of the neighbor cluster of the provided `clusterIds` list. The paginated nodes (clusters) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Cluster graph (Neighbor)
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {Array<string>} clusterIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanClusterGraphNeighbor: function (id, page, size, clusterIds, options) {
            return localVarFp.getAddressScanClusterGraphNeighbor(id, page, size, clusterIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the Payment flows graph of an address scan. The paginated nodes (addresses) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Payment flow graph
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanFlowGraph: function (id, page, size, options) {
            return localVarFp.getAddressScanFlowGraph(id, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the Payment flows graph of an address scan. The returned nodes (address) and edges (transactions) will only consist of the neighbor address of the provided `addresses` list. The paginated nodes (addresses) and edges (transactions) subset are ordered by topology ordering.
         * @summary Get scanning result: Payment flow graph (Neighbor)
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {Array<string>} addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanFlowGraphNeibor: function (id, page, size, addresses, options) {
            return localVarFp.getAddressScanFlowGraphNeibor(id, page, size, addresses, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the forward and backward labels distribution of an address scanning.
         * @summary Get scanning result: Label distribution
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanLabelSunburst: function (id, options) {
            return localVarFp.getAddressScanLabelSunburst(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a page of address scan history.
         * @summary Find address scan history
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [batchId]
         * @param {string} [chainId]
         * @param {string} [assetId]
         * @param {string} [address]
         * @param {string} [incidentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressScan: function (page, size, projectId, batchId, chainId, assetId, address, incidentId, options) {
            return localVarFp.paginateAddressScan(page, size, projectId, batchId, chainId, assetId, address, incidentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the issue list of an address scan.
         * @summary Get scanning result: Issue list
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {'SEND' | 'RECEIVE' | 'PREDICT' | 'OTHER'} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressScanWitness: function (id, page, size, category, options) {
            return localVarFp.paginateAddressScanWitness(id, page, size, category, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AddressScanApi - object-oriented interface
 * @export
 * @class AddressScanApi
 * @extends {BaseAPI}
 */
var AddressScanApi = /** @class */ (function (_super) {
    __extends(AddressScanApi, _super);
    function AddressScanApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create an address scan
     * @param {AddressScanCreation} addressScanCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanApi
     */
    AddressScanApi.prototype.createAddressScan = function (addressScanCreation, options) {
        var _this = this;
        return exports.AddressScanApiFp(this.configuration).createAddressScan(addressScanCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns an address scan record by ID.
     * @summary Get Address Scan by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanApi
     */
    AddressScanApi.prototype.getAddressScan = function (id, options) {
        var _this = this;
        return exports.AddressScanApiFp(this.configuration).getAddressScan(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the Clustered payment flows graph of an address scan. The paginated nodes (clusters) and edges (transactions) subset are ordered by topology ordering.
     * @summary Get scanning result: Cluster graph
     * @param {string} id
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanApi
     */
    AddressScanApi.prototype.getAddressScanClusterGraph = function (id, page, size, options) {
        var _this = this;
        return exports.AddressScanApiFp(this.configuration).getAddressScanClusterGraph(id, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the Clustered payment flows graph of an address scan. The returned nodes (clusters) and edges (transactions) will only consist of the neighbor cluster of the provided `clusterIds` list. The paginated nodes (clusters) and edges (transactions) subset are ordered by topology ordering.
     * @summary Get scanning result: Cluster graph (Neighbor)
     * @param {string} id
     * @param {number} page
     * @param {number} size
     * @param {Array<string>} clusterIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanApi
     */
    AddressScanApi.prototype.getAddressScanClusterGraphNeighbor = function (id, page, size, clusterIds, options) {
        var _this = this;
        return exports.AddressScanApiFp(this.configuration).getAddressScanClusterGraphNeighbor(id, page, size, clusterIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the Payment flows graph of an address scan. The paginated nodes (addresses) and edges (transactions) subset are ordered by topology ordering.
     * @summary Get scanning result: Payment flow graph
     * @param {string} id
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanApi
     */
    AddressScanApi.prototype.getAddressScanFlowGraph = function (id, page, size, options) {
        var _this = this;
        return exports.AddressScanApiFp(this.configuration).getAddressScanFlowGraph(id, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the Payment flows graph of an address scan. The returned nodes (address) and edges (transactions) will only consist of the neighbor address of the provided `addresses` list. The paginated nodes (addresses) and edges (transactions) subset are ordered by topology ordering.
     * @summary Get scanning result: Payment flow graph (Neighbor)
     * @param {string} id
     * @param {number} page
     * @param {number} size
     * @param {Array<string>} addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanApi
     */
    AddressScanApi.prototype.getAddressScanFlowGraphNeibor = function (id, page, size, addresses, options) {
        var _this = this;
        return exports.AddressScanApiFp(this.configuration).getAddressScanFlowGraphNeibor(id, page, size, addresses, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the forward and backward labels distribution of an address scanning.
     * @summary Get scanning result: Label distribution
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanApi
     */
    AddressScanApi.prototype.getAddressScanLabelSunburst = function (id, options) {
        var _this = this;
        return exports.AddressScanApiFp(this.configuration).getAddressScanLabelSunburst(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a page of address scan history.
     * @summary Find address scan history
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [projectId]
     * @param {string} [batchId]
     * @param {string} [chainId]
     * @param {string} [assetId]
     * @param {string} [address]
     * @param {string} [incidentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanApi
     */
    AddressScanApi.prototype.paginateAddressScan = function (page, size, projectId, batchId, chainId, assetId, address, incidentId, options) {
        var _this = this;
        return exports.AddressScanApiFp(this.configuration).paginateAddressScan(page, size, projectId, batchId, chainId, assetId, address, incidentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the issue list of an address scan.
     * @summary Get scanning result: Issue list
     * @param {string} id
     * @param {number} page
     * @param {number} size
     * @param {'SEND' | 'RECEIVE' | 'PREDICT' | 'OTHER'} [category]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanApi
     */
    AddressScanApi.prototype.paginateAddressScanWitness = function (id, page, size, category, options) {
        var _this = this;
        return exports.AddressScanApiFp(this.configuration).paginateAddressScanWitness(id, page, size, category, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressScanApi;
}(base_1.BaseAPI));
exports.AddressScanApi = AddressScanApi;
/**
 * AddressScanBatchApi - axios parameter creator
 * @export
 */
exports.AddressScanBatchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create an address scan batch from a JSON address list
         * @summary Create an address scan batch (List)
         * @param {AddressScanBatchCreation} addressScanBatchCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressScanBatch: function (addressScanBatchCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressScanBatchCreation' is not null or undefined
                            common_1.assertParamExists('createAddressScanBatch', 'addressScanBatchCreation', addressScanBatchCreation);
                            localVarPath = "/api/address-scan-batch";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addressScanBatchCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create an address scan batch fFrom a CSV file that contains address list
         * @summary Create an address scan batch (CSV)
         * @param {AddressScanBatchCreationFromBlob} addressScanBatchCreationFromBlob
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressScanBatchFromBlob: function (addressScanBatchCreationFromBlob, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressScanBatchCreationFromBlob' is not null or undefined
                            common_1.assertParamExists('createAddressScanBatchFromBlob', 'addressScanBatchCreationFromBlob', addressScanBatchCreationFromBlob);
                            localVarPath = "/api/address-scan-batch/csv";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addressScanBatchCreationFromBlob, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns an address scan batch by ID.
         * @summary Get address batch by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanBatch: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAddressScanBatch', 'id', id);
                            localVarPath = "/api/address-scan-batch/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a page of address scan batch history.
         * @summary Find address scan batches
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressScanBatch: function (page, size, projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/address-scan-batch";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AddressScanBatchApi - functional programming interface
 * @export
 */
exports.AddressScanBatchApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AddressScanBatchApiAxiosParamCreator(configuration);
    return {
        /**
         * Create an address scan batch from a JSON address list
         * @summary Create an address scan batch (List)
         * @param {AddressScanBatchCreation} addressScanBatchCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressScanBatch: function (addressScanBatchCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAddressScanBatch(addressScanBatchCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create an address scan batch fFrom a CSV file that contains address list
         * @summary Create an address scan batch (CSV)
         * @param {AddressScanBatchCreationFromBlob} addressScanBatchCreationFromBlob
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressScanBatchFromBlob: function (addressScanBatchCreationFromBlob, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAddressScanBatchFromBlob(addressScanBatchCreationFromBlob, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns an address scan batch by ID.
         * @summary Get address batch by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanBatch: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddressScanBatch(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a page of address scan batch history.
         * @summary Find address scan batches
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressScanBatch: function (page, size, projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateAddressScanBatch(page, size, projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AddressScanBatchApi - factory interface
 * @export
 */
exports.AddressScanBatchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AddressScanBatchApiFp(configuration);
    return {
        /**
         * Create an address scan batch from a JSON address list
         * @summary Create an address scan batch (List)
         * @param {AddressScanBatchCreation} addressScanBatchCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressScanBatch: function (addressScanBatchCreation, options) {
            return localVarFp.createAddressScanBatch(addressScanBatchCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create an address scan batch fFrom a CSV file that contains address list
         * @summary Create an address scan batch (CSV)
         * @param {AddressScanBatchCreationFromBlob} addressScanBatchCreationFromBlob
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressScanBatchFromBlob: function (addressScanBatchCreationFromBlob, options) {
            return localVarFp.createAddressScanBatchFromBlob(addressScanBatchCreationFromBlob, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns an address scan batch by ID.
         * @summary Get address batch by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressScanBatch: function (id, options) {
            return localVarFp.getAddressScanBatch(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a page of address scan batch history.
         * @summary Find address scan batches
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAddressScanBatch: function (page, size, projectId, options) {
            return localVarFp.paginateAddressScanBatch(page, size, projectId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AddressScanBatchApi - object-oriented interface
 * @export
 * @class AddressScanBatchApi
 * @extends {BaseAPI}
 */
var AddressScanBatchApi = /** @class */ (function (_super) {
    __extends(AddressScanBatchApi, _super);
    function AddressScanBatchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create an address scan batch from a JSON address list
     * @summary Create an address scan batch (List)
     * @param {AddressScanBatchCreation} addressScanBatchCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanBatchApi
     */
    AddressScanBatchApi.prototype.createAddressScanBatch = function (addressScanBatchCreation, options) {
        var _this = this;
        return exports.AddressScanBatchApiFp(this.configuration).createAddressScanBatch(addressScanBatchCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create an address scan batch fFrom a CSV file that contains address list
     * @summary Create an address scan batch (CSV)
     * @param {AddressScanBatchCreationFromBlob} addressScanBatchCreationFromBlob
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanBatchApi
     */
    AddressScanBatchApi.prototype.createAddressScanBatchFromBlob = function (addressScanBatchCreationFromBlob, options) {
        var _this = this;
        return exports.AddressScanBatchApiFp(this.configuration).createAddressScanBatchFromBlob(addressScanBatchCreationFromBlob, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns an address scan batch by ID.
     * @summary Get address batch by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanBatchApi
     */
    AddressScanBatchApi.prototype.getAddressScanBatch = function (id, options) {
        var _this = this;
        return exports.AddressScanBatchApiFp(this.configuration).getAddressScanBatch(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a page of address scan batch history.
     * @summary Find address scan batches
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [projectId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressScanBatchApi
     */
    AddressScanBatchApi.prototype.paginateAddressScanBatch = function (page, size, projectId, options) {
        var _this = this;
        return exports.AddressScanBatchApiFp(this.configuration).paginateAddressScanBatch(page, size, projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressScanBatchApi;
}(base_1.BaseAPI));
exports.AddressScanBatchApi = AddressScanBatchApi;
/**
 * ApiKeyApi - axios parameter creator
 * @export
 */
exports.ApiKeyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {ApiKeyCreation} apiKeyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey: function (apiKeyCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'apiKeyCreation' is not null or undefined
                            common_1.assertParamExists('createApiKey', 'apiKeyCreation', apiKeyCreation);
                            localVarPath = "/api/api-key";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiKeyCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ApiKeyApi - functional programming interface
 * @export
 */
exports.ApiKeyApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ApiKeyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiKeyCreation} apiKeyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey: function (apiKeyCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createApiKey(apiKeyCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ApiKeyApi - factory interface
 * @export
 */
exports.ApiKeyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ApiKeyApiFp(configuration);
    return {
        /**
         *
         * @param {ApiKeyCreation} apiKeyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey: function (apiKeyCreation, options) {
            return localVarFp.createApiKey(apiKeyCreation, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ApiKeyApi - object-oriented interface
 * @export
 * @class ApiKeyApi
 * @extends {BaseAPI}
 */
var ApiKeyApi = /** @class */ (function (_super) {
    __extends(ApiKeyApi, _super);
    function ApiKeyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {ApiKeyCreation} apiKeyCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeyApi
     */
    ApiKeyApi.prototype.createApiKey = function (apiKeyCreation, options) {
        var _this = this;
        return exports.ApiKeyApiFp(this.configuration).createApiKey(apiKeyCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApiKeyApi;
}(base_1.BaseAPI));
exports.ApiKeyApi = ApiKeyApi;
/**
 * AssetApi - axios parameter creator
 * @export
 */
exports.AssetApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns an asset by ID.
         * @summary Get asset by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeAsset: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('describeAsset', 'id', id);
                            localVarPath = "/api/asset/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns assets
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [chainId]
         * @param {boolean} [scannableOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssets: function (page, size, chainId, scannableOnly, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/asset";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (scannableOnly !== undefined) {
                                localVarQueryParameter['scannableOnly'] = scannableOnly;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AssetApi - functional programming interface
 * @export
 */
exports.AssetApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AssetApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns an asset by ID.
         * @summary Get asset by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeAsset: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.describeAsset(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns assets
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [chainId]
         * @param {boolean} [scannableOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssets: function (page, size, chainId, scannableOnly, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listAssets(page, size, chainId, scannableOnly, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AssetApi - factory interface
 * @export
 */
exports.AssetApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AssetApiFp(configuration);
    return {
        /**
         * Returns an asset by ID.
         * @summary Get asset by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeAsset: function (id, options) {
            return localVarFp.describeAsset(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns assets
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [chainId]
         * @param {boolean} [scannableOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssets: function (page, size, chainId, scannableOnly, options) {
            return localVarFp.listAssets(page, size, chainId, scannableOnly, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AssetApi - object-oriented interface
 * @export
 * @class AssetApi
 * @extends {BaseAPI}
 */
var AssetApi = /** @class */ (function (_super) {
    __extends(AssetApi, _super);
    function AssetApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns an asset by ID.
     * @summary Get asset by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    AssetApi.prototype.describeAsset = function (id, options) {
        var _this = this;
        return exports.AssetApiFp(this.configuration).describeAsset(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns assets
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [chainId]
     * @param {boolean} [scannableOnly]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    AssetApi.prototype.listAssets = function (page, size, chainId, scannableOnly, options) {
        var _this = this;
        return exports.AssetApiFp(this.configuration).listAssets(page, size, chainId, scannableOnly, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AssetApi;
}(base_1.BaseAPI));
exports.AssetApi = AssetApi;
/**
 * BlobApi - axios parameter creator
 * @export
 */
exports.BlobApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Uploads a file and returns the blob metadata.
         * @summary Uploads a file
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlob: function (file, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'file' is not null or undefined
                            common_1.assertParamExists('createBlob', 'file', file);
                            localVarPath = "/api/blob";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * BlobApi - functional programming interface
 * @export
 */
exports.BlobApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.BlobApiAxiosParamCreator(configuration);
    return {
        /**
         * Uploads a file and returns the blob metadata.
         * @summary Uploads a file
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlob: function (file, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBlob(file, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * BlobApi - factory interface
 * @export
 */
exports.BlobApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.BlobApiFp(configuration);
    return {
        /**
         * Uploads a file and returns the blob metadata.
         * @summary Uploads a file
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlob: function (file, options) {
            return localVarFp.createBlob(file, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * BlobApi - object-oriented interface
 * @export
 * @class BlobApi
 * @extends {BaseAPI}
 */
var BlobApi = /** @class */ (function (_super) {
    __extends(BlobApi, _super);
    function BlobApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Uploads a file and returns the blob metadata.
     * @summary Uploads a file
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobApi
     */
    BlobApi.prototype.createBlob = function (file, options) {
        var _this = this;
        return exports.BlobApiFp(this.configuration).createBlob(file, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BlobApi;
}(base_1.BaseAPI));
exports.BlobApi = BlobApi;
/**
 * ChainApi - axios parameter creator
 * @export
 */
exports.ChainApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a chain by ID.
         * @summary Get chain by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeChain: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('describeChain', 'id', id);
                            localVarPath = "/api/chain/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all chains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChains: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/chain";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all labels of a specific address.
         * @summary Search label by address (Deprecated)
         * @param {string} id Chain ID
         * @param {string} address Address
         * @param {string} projectId Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLabels: function (id, address, projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('searchLabels', 'id', id);
                            // verify required parameter 'address' is not null or undefined
                            common_1.assertParamExists('searchLabels', 'address', address);
                            // verify required parameter 'projectId' is not null or undefined
                            common_1.assertParamExists('searchLabels', 'projectId', projectId);
                            localVarPath = "/api/chain/{id}/address/{address}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "address" + "}", encodeURIComponent(String(address)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ChainApi - functional programming interface
 * @export
 */
exports.ChainApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ChainApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a chain by ID.
         * @summary Get chain by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeChain: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.describeChain(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all chains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChains: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listChains(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all labels of a specific address.
         * @summary Search label by address (Deprecated)
         * @param {string} id Chain ID
         * @param {string} address Address
         * @param {string} projectId Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLabels: function (id, address, projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchLabels(id, address, projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ChainApi - factory interface
 * @export
 */
exports.ChainApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ChainApiFp(configuration);
    return {
        /**
         * Returns a chain by ID.
         * @summary Get chain by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeChain: function (id, options) {
            return localVarFp.describeChain(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns all chains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChains: function (options) {
            return localVarFp.listChains(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all labels of a specific address.
         * @summary Search label by address (Deprecated)
         * @param {string} id Chain ID
         * @param {string} address Address
         * @param {string} projectId Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLabels: function (id, address, projectId, options) {
            return localVarFp.searchLabels(id, address, projectId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ChainApi - object-oriented interface
 * @export
 * @class ChainApi
 * @extends {BaseAPI}
 */
var ChainApi = /** @class */ (function (_super) {
    __extends(ChainApi, _super);
    function ChainApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a chain by ID.
     * @summary Get chain by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChainApi
     */
    ChainApi.prototype.describeChain = function (id, options) {
        var _this = this;
        return exports.ChainApiFp(this.configuration).describeChain(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns all chains
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChainApi
     */
    ChainApi.prototype.listChains = function (options) {
        var _this = this;
        return exports.ChainApiFp(this.configuration).listChains(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all labels of a specific address.
     * @summary Search label by address (Deprecated)
     * @param {string} id Chain ID
     * @param {string} address Address
     * @param {string} projectId Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChainApi
     */
    ChainApi.prototype.searchLabels = function (id, address, projectId, options) {
        var _this = this;
        return exports.ChainApiFp(this.configuration).searchLabels(id, address, projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ChainApi;
}(base_1.BaseAPI));
exports.ChainApi = ChainApi;
/**
 * CheckApi - axios parameter creator
 * @export
 */
exports.CheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns the interaction summary data by specific account and interaction type.
         * @summary Web3 Check Single Account Interaction
         * @param {'ALL' | 'RECEIVED' | 'SENT'} type Type
         * @param {string} chainId Chain ID
         * @param {string} address Address
         * @param {string} txTimeStart Time Start
         * @param {string} txTimeEnd Time End
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountInteraction: function (type, chainId, address, txTimeStart, txTimeEnd, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'type' is not null or undefined
                            common_1.assertParamExists('getAccountInteraction', 'type', type);
                            // verify required parameter 'chainId' is not null or undefined
                            common_1.assertParamExists('getAccountInteraction', 'chainId', chainId);
                            // verify required parameter 'address' is not null or undefined
                            common_1.assertParamExists('getAccountInteraction', 'address', address);
                            // verify required parameter 'txTimeStart' is not null or undefined
                            common_1.assertParamExists('getAccountInteraction', 'txTimeStart', txTimeStart);
                            // verify required parameter 'txTimeEnd' is not null or undefined
                            common_1.assertParamExists('getAccountInteraction', 'txTimeEnd', txTimeEnd);
                            localVarPath = "/api/check/account/interaction";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (address !== undefined) {
                                localVarQueryParameter['address'] = address;
                            }
                            if (txTimeStart !== undefined) {
                                localVarQueryParameter['txTimeStart'] = txTimeStart;
                            }
                            if (txTimeEnd !== undefined) {
                                localVarQueryParameter['txTimeEnd'] = txTimeEnd;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns activity summary information of specific account.
         * @summary Get account activity summary
         * @param {string} chainId Chain ID
         * @param {string} address Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressActivity: function (chainId, address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'chainId' is not null or undefined
                            common_1.assertParamExists('getAddressActivity', 'chainId', chainId);
                            // verify required parameter 'address' is not null or undefined
                            common_1.assertParamExists('getAddressActivity', 'address', address);
                            localVarPath = "/api/check/account/activity";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (address !== undefined) {
                                localVarQueryParameter['address'] = address;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check web3 entity by keyword. Returns anti-fraud credit and labels of related entities
         * @summary Web3 Check
         * @param {string} keyword Keyword. For example: web3 address, url, domain name, IP.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        web3Check: function (keyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'keyword' is not null or undefined
                            common_1.assertParamExists('web3Check', 'keyword', keyword);
                            localVarPath = "/api/check";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (keyword !== undefined) {
                                localVarQueryParameter['keyword'] = keyword;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns anti-fraud credit and risk level of a specific account
         * @summary Web3 Check Single Account
         * @param {string} chainId Chain ID
         * @param {string} address Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        web3CheckSingleAccount: function (chainId, address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'chainId' is not null or undefined
                            common_1.assertParamExists('web3CheckSingleAccount', 'chainId', chainId);
                            // verify required parameter 'address' is not null or undefined
                            common_1.assertParamExists('web3CheckSingleAccount', 'address', address);
                            localVarPath = "/api/check/account";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (address !== undefined) {
                                localVarQueryParameter['address'] = address;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CheckApi - functional programming interface
 * @export
 */
exports.CheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.CheckApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns the interaction summary data by specific account and interaction type.
         * @summary Web3 Check Single Account Interaction
         * @param {'ALL' | 'RECEIVED' | 'SENT'} type Type
         * @param {string} chainId Chain ID
         * @param {string} address Address
         * @param {string} txTimeStart Time Start
         * @param {string} txTimeEnd Time End
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountInteraction: function (type, chainId, address, txTimeStart, txTimeEnd, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountInteraction(type, chainId, address, txTimeStart, txTimeEnd, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns activity summary information of specific account.
         * @summary Get account activity summary
         * @param {string} chainId Chain ID
         * @param {string} address Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressActivity: function (chainId, address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddressActivity(chainId, address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Check web3 entity by keyword. Returns anti-fraud credit and labels of related entities
         * @summary Web3 Check
         * @param {string} keyword Keyword. For example: web3 address, url, domain name, IP.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        web3Check: function (keyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.web3Check(keyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns anti-fraud credit and risk level of a specific account
         * @summary Web3 Check Single Account
         * @param {string} chainId Chain ID
         * @param {string} address Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        web3CheckSingleAccount: function (chainId, address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.web3CheckSingleAccount(chainId, address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * CheckApi - factory interface
 * @export
 */
exports.CheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.CheckApiFp(configuration);
    return {
        /**
         * Returns the interaction summary data by specific account and interaction type.
         * @summary Web3 Check Single Account Interaction
         * @param {'ALL' | 'RECEIVED' | 'SENT'} type Type
         * @param {string} chainId Chain ID
         * @param {string} address Address
         * @param {string} txTimeStart Time Start
         * @param {string} txTimeEnd Time End
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountInteraction: function (type, chainId, address, txTimeStart, txTimeEnd, options) {
            return localVarFp.getAccountInteraction(type, chainId, address, txTimeStart, txTimeEnd, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns activity summary information of specific account.
         * @summary Get account activity summary
         * @param {string} chainId Chain ID
         * @param {string} address Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressActivity: function (chainId, address, options) {
            return localVarFp.getAddressActivity(chainId, address, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check web3 entity by keyword. Returns anti-fraud credit and labels of related entities
         * @summary Web3 Check
         * @param {string} keyword Keyword. For example: web3 address, url, domain name, IP.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        web3Check: function (keyword, options) {
            return localVarFp.web3Check(keyword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns anti-fraud credit and risk level of a specific account
         * @summary Web3 Check Single Account
         * @param {string} chainId Chain ID
         * @param {string} address Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        web3CheckSingleAccount: function (chainId, address, options) {
            return localVarFp.web3CheckSingleAccount(chainId, address, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CheckApi - object-oriented interface
 * @export
 * @class CheckApi
 * @extends {BaseAPI}
 */
var CheckApi = /** @class */ (function (_super) {
    __extends(CheckApi, _super);
    function CheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the interaction summary data by specific account and interaction type.
     * @summary Web3 Check Single Account Interaction
     * @param {'ALL' | 'RECEIVED' | 'SENT'} type Type
     * @param {string} chainId Chain ID
     * @param {string} address Address
     * @param {string} txTimeStart Time Start
     * @param {string} txTimeEnd Time End
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckApi
     */
    CheckApi.prototype.getAccountInteraction = function (type, chainId, address, txTimeStart, txTimeEnd, options) {
        var _this = this;
        return exports.CheckApiFp(this.configuration).getAccountInteraction(type, chainId, address, txTimeStart, txTimeEnd, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns activity summary information of specific account.
     * @summary Get account activity summary
     * @param {string} chainId Chain ID
     * @param {string} address Address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckApi
     */
    CheckApi.prototype.getAddressActivity = function (chainId, address, options) {
        var _this = this;
        return exports.CheckApiFp(this.configuration).getAddressActivity(chainId, address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check web3 entity by keyword. Returns anti-fraud credit and labels of related entities
     * @summary Web3 Check
     * @param {string} keyword Keyword. For example: web3 address, url, domain name, IP.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckApi
     */
    CheckApi.prototype.web3Check = function (keyword, options) {
        var _this = this;
        return exports.CheckApiFp(this.configuration).web3Check(keyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns anti-fraud credit and risk level of a specific account
     * @summary Web3 Check Single Account
     * @param {string} chainId Chain ID
     * @param {string} address Address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckApi
     */
    CheckApi.prototype.web3CheckSingleAccount = function (chainId, address, options) {
        var _this = this;
        return exports.CheckApiFp(this.configuration).web3CheckSingleAccount(chainId, address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CheckApi;
}(base_1.BaseAPI));
exports.CheckApi = CheckApi;
/**
 * ContentfulApi - axios parameter creator
 * @export
 */
exports.ContentfulApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asset: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('asset', 'id', id);
                            localVarPath = "/api/contentful/asset";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entries: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/contentful/entries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entry: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('entry', 'id', id);
                            localVarPath = "/api/contentful/entry";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ContentfulApi - functional programming interface
 * @export
 */
exports.ContentfulApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ContentfulApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asset: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.asset(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entries: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.entries(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entry: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.entry(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ContentfulApi - factory interface
 * @export
 */
exports.ContentfulApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ContentfulApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asset: function (id, options) {
            return localVarFp.asset(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entries: function (options) {
            return localVarFp.entries(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entry: function (id, options) {
            return localVarFp.entry(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ContentfulApi - object-oriented interface
 * @export
 * @class ContentfulApi
 * @extends {BaseAPI}
 */
var ContentfulApi = /** @class */ (function (_super) {
    __extends(ContentfulApi, _super);
    function ContentfulApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentfulApi
     */
    ContentfulApi.prototype.asset = function (id, options) {
        var _this = this;
        return exports.ContentfulApiFp(this.configuration).asset(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentfulApi
     */
    ContentfulApi.prototype.entries = function (options) {
        var _this = this;
        return exports.ContentfulApiFp(this.configuration).entries(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentfulApi
     */
    ContentfulApi.prototype.entry = function (id, options) {
        var _this = this;
        return exports.ContentfulApiFp(this.configuration).entry(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContentfulApi;
}(base_1.BaseAPI));
exports.ContentfulApi = ContentfulApi;
/**
 * DomainApi - axios parameter creator
 * @export
 */
exports.DomainApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Invalidate domain listing cache
         * @summary Invalidate cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateDomainCaches: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/domain/cache";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * DomainApi - functional programming interface
 * @export
 */
exports.DomainApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.DomainApiAxiosParamCreator(configuration);
    return {
        /**
         * Invalidate domain listing cache
         * @summary Invalidate cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateDomainCaches: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invalidateDomainCaches(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DomainApi - factory interface
 * @export
 */
exports.DomainApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.DomainApiFp(configuration);
    return {
        /**
         * Invalidate domain listing cache
         * @summary Invalidate cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateDomainCaches: function (options) {
            return localVarFp.invalidateDomainCaches(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * DomainApi - object-oriented interface
 * @export
 * @class DomainApi
 * @extends {BaseAPI}
 */
var DomainApi = /** @class */ (function (_super) {
    __extends(DomainApi, _super);
    function DomainApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Invalidate domain listing cache
     * @summary Invalidate cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    DomainApi.prototype.invalidateDomainCaches = function (options) {
        var _this = this;
        return exports.DomainApiFp(this.configuration).invalidateDomainCaches(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DomainApi;
}(base_1.BaseAPI));
exports.DomainApi = DomainApi;
/**
 * ExchangeApi - axios parameter creator
 * @export
 */
exports.ExchangeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a exchange by ID.
         * @summary Get exchange by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeExchange: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('describeExchange', 'id', id);
                            localVarPath = "/api/exchange/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns status of all exchanges.
         * @summary Get all exchange status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExchangeStatus: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/exchange/status";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all exchanges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExchanges: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/exchange";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ExchangeApi - functional programming interface
 * @export
 */
exports.ExchangeApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ExchangeApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a exchange by ID.
         * @summary Get exchange by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeExchange: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.describeExchange(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns status of all exchanges.
         * @summary Get all exchange status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExchangeStatus: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listExchangeStatus(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all exchanges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExchanges: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listExchanges(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ExchangeApi - factory interface
 * @export
 */
exports.ExchangeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ExchangeApiFp(configuration);
    return {
        /**
         * Returns a exchange by ID.
         * @summary Get exchange by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeExchange: function (id, options) {
            return localVarFp.describeExchange(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns status of all exchanges.
         * @summary Get all exchange status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExchangeStatus: function (options) {
            return localVarFp.listExchangeStatus(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns all exchanges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExchanges: function (options) {
            return localVarFp.listExchanges(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ExchangeApi - object-oriented interface
 * @export
 * @class ExchangeApi
 * @extends {BaseAPI}
 */
var ExchangeApi = /** @class */ (function (_super) {
    __extends(ExchangeApi, _super);
    function ExchangeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a exchange by ID.
     * @summary Get exchange by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExchangeApi
     */
    ExchangeApi.prototype.describeExchange = function (id, options) {
        var _this = this;
        return exports.ExchangeApiFp(this.configuration).describeExchange(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns status of all exchanges.
     * @summary Get all exchange status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExchangeApi
     */
    ExchangeApi.prototype.listExchangeStatus = function (options) {
        var _this = this;
        return exports.ExchangeApiFp(this.configuration).listExchangeStatus(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns all exchanges
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExchangeApi
     */
    ExchangeApi.prototype.listExchanges = function (options) {
        var _this = this;
        return exports.ExchangeApiFp(this.configuration).listExchanges(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ExchangeApi;
}(base_1.BaseAPI));
exports.ExchangeApi = ExchangeApi;
/**
 * FeedbackApi - axios parameter creator
 * @export
 */
exports.FeedbackApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Submit a new feedback
         * @summary Submit feedback
         * @param {UserFeedbackForm} userFeedbackForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedback: function (userFeedbackForm, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userFeedbackForm' is not null or undefined
                            common_1.assertParamExists('submitFeedback', 'userFeedbackForm', userFeedbackForm);
                            localVarPath = "/api/feedback";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(userFeedbackForm, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Submit a new feedback without login
         * @summary Submit feedback (anonymous)
         * @param {AnonymousFeedbackForm} anonymousFeedbackForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedbackAnonymously: function (anonymousFeedbackForm, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'anonymousFeedbackForm' is not null or undefined
                            common_1.assertParamExists('submitFeedbackAnonymously', 'anonymousFeedbackForm', anonymousFeedbackForm);
                            localVarPath = "/api/feedback/anonymous";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(anonymousFeedbackForm, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * FeedbackApi - functional programming interface
 * @export
 */
exports.FeedbackApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.FeedbackApiAxiosParamCreator(configuration);
    return {
        /**
         * Submit a new feedback
         * @summary Submit feedback
         * @param {UserFeedbackForm} userFeedbackForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedback: function (userFeedbackForm, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.submitFeedback(userFeedbackForm, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Submit a new feedback without login
         * @summary Submit feedback (anonymous)
         * @param {AnonymousFeedbackForm} anonymousFeedbackForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedbackAnonymously: function (anonymousFeedbackForm, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.submitFeedbackAnonymously(anonymousFeedbackForm, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * FeedbackApi - factory interface
 * @export
 */
exports.FeedbackApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.FeedbackApiFp(configuration);
    return {
        /**
         * Submit a new feedback
         * @summary Submit feedback
         * @param {UserFeedbackForm} userFeedbackForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedback: function (userFeedbackForm, options) {
            return localVarFp.submitFeedback(userFeedbackForm, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Submit a new feedback without login
         * @summary Submit feedback (anonymous)
         * @param {AnonymousFeedbackForm} anonymousFeedbackForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedbackAnonymously: function (anonymousFeedbackForm, options) {
            return localVarFp.submitFeedbackAnonymously(anonymousFeedbackForm, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * FeedbackApi - object-oriented interface
 * @export
 * @class FeedbackApi
 * @extends {BaseAPI}
 */
var FeedbackApi = /** @class */ (function (_super) {
    __extends(FeedbackApi, _super);
    function FeedbackApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Submit a new feedback
     * @summary Submit feedback
     * @param {UserFeedbackForm} userFeedbackForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    FeedbackApi.prototype.submitFeedback = function (userFeedbackForm, options) {
        var _this = this;
        return exports.FeedbackApiFp(this.configuration).submitFeedback(userFeedbackForm, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Submit a new feedback without login
     * @summary Submit feedback (anonymous)
     * @param {AnonymousFeedbackForm} anonymousFeedbackForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    FeedbackApi.prototype.submitFeedbackAnonymously = function (anonymousFeedbackForm, options) {
        var _this = this;
        return exports.FeedbackApiFp(this.configuration).submitFeedbackAnonymously(anonymousFeedbackForm, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FeedbackApi;
}(base_1.BaseAPI));
exports.FeedbackApi = FeedbackApi;
/**
 * FlowLabelingApi - axios parameter creator
 * @export
 */
exports.FlowLabelingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {FlowLabelingCreation} flowLabelingCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowLabeling: function (flowLabelingCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowLabelingCreation' is not null or undefined
                            common_1.assertParamExists('createFlowLabeling', 'flowLabelingCreation', flowLabelingCreation);
                            localVarPath = "/api/flow-labeling";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(flowLabelingCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * FlowLabelingApi - functional programming interface
 * @export
 */
exports.FlowLabelingApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.FlowLabelingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {FlowLabelingCreation} flowLabelingCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowLabeling: function (flowLabelingCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFlowLabeling(flowLabelingCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * FlowLabelingApi - factory interface
 * @export
 */
exports.FlowLabelingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.FlowLabelingApiFp(configuration);
    return {
        /**
         *
         * @param {FlowLabelingCreation} flowLabelingCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowLabeling: function (flowLabelingCreation, options) {
            return localVarFp.createFlowLabeling(flowLabelingCreation, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * FlowLabelingApi - object-oriented interface
 * @export
 * @class FlowLabelingApi
 * @extends {BaseAPI}
 */
var FlowLabelingApi = /** @class */ (function (_super) {
    __extends(FlowLabelingApi, _super);
    function FlowLabelingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {FlowLabelingCreation} flowLabelingCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowLabelingApi
     */
    FlowLabelingApi.prototype.createFlowLabeling = function (flowLabelingCreation, options) {
        var _this = this;
        return exports.FlowLabelingApiFp(this.configuration).createFlowLabeling(flowLabelingCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FlowLabelingApi;
}(base_1.BaseAPI));
exports.FlowLabelingApi = FlowLabelingApi;
/**
 * HolderApi - axios parameter creator
 * @export
 */
exports.HolderApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {HolderCreation} holderCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolder: function (holderCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'holderCreation' is not null or undefined
                            common_1.assertParamExists('createHolder', 'holderCreation', holderCreation);
                            localVarPath = "/api/holder";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(holderCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolder: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteHolder', 'id', id);
                            localVarPath = "/api/holder/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolder: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getHolder', 'id', id);
                            localVarPath = "/api/holder/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [legalName]
         * @param {string} [clientId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateHolder: function (page, size, projectId, legalName, clientId, chainId, address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/holder";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            if (legalName !== undefined) {
                                localVarQueryParameter['legalName'] = legalName;
                            }
                            if (clientId !== undefined) {
                                localVarQueryParameter['clientId'] = clientId;
                            }
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (address !== undefined) {
                                localVarQueryParameter['address'] = address;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {HolderUpdates} holderUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHolder: function (id, holderUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateHolder', 'id', id);
                            // verify required parameter 'holderUpdates' is not null or undefined
                            common_1.assertParamExists('updateHolder', 'holderUpdates', holderUpdates);
                            localVarPath = "/api/holder/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(holderUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * HolderApi - functional programming interface
 * @export
 */
exports.HolderApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.HolderApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {HolderCreation} holderCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolder: function (holderCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createHolder(holderCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolder: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteHolder(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolder: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getHolder(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [legalName]
         * @param {string} [clientId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateHolder: function (page, size, projectId, legalName, clientId, chainId, address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateHolder(page, size, projectId, legalName, clientId, chainId, address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {HolderUpdates} holderUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHolder: function (id, holderUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateHolder(id, holderUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * HolderApi - factory interface
 * @export
 */
exports.HolderApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.HolderApiFp(configuration);
    return {
        /**
         *
         * @param {HolderCreation} holderCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolder: function (holderCreation, options) {
            return localVarFp.createHolder(holderCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolder: function (id, options) {
            return localVarFp.deleteHolder(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolder: function (id, options) {
            return localVarFp.getHolder(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [legalName]
         * @param {string} [clientId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateHolder: function (page, size, projectId, legalName, clientId, chainId, address, options) {
            return localVarFp.paginateHolder(page, size, projectId, legalName, clientId, chainId, address, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {HolderUpdates} holderUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHolder: function (id, holderUpdates, options) {
            return localVarFp.updateHolder(id, holderUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * HolderApi - object-oriented interface
 * @export
 * @class HolderApi
 * @extends {BaseAPI}
 */
var HolderApi = /** @class */ (function (_super) {
    __extends(HolderApi, _super);
    function HolderApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {HolderCreation} holderCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderApi
     */
    HolderApi.prototype.createHolder = function (holderCreation, options) {
        var _this = this;
        return exports.HolderApiFp(this.configuration).createHolder(holderCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderApi
     */
    HolderApi.prototype.deleteHolder = function (id, options) {
        var _this = this;
        return exports.HolderApiFp(this.configuration).deleteHolder(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderApi
     */
    HolderApi.prototype.getHolder = function (id, options) {
        var _this = this;
        return exports.HolderApiFp(this.configuration).getHolder(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [projectId]
     * @param {string} [legalName]
     * @param {string} [clientId]
     * @param {string} [chainId]
     * @param {string} [address]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderApi
     */
    HolderApi.prototype.paginateHolder = function (page, size, projectId, legalName, clientId, chainId, address, options) {
        var _this = this;
        return exports.HolderApiFp(this.configuration).paginateHolder(page, size, projectId, legalName, clientId, chainId, address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {HolderUpdates} holderUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderApi
     */
    HolderApi.prototype.updateHolder = function (id, holderUpdates, options) {
        var _this = this;
        return exports.HolderApiFp(this.configuration).updateHolder(id, holderUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HolderApi;
}(base_1.BaseAPI));
exports.HolderApi = HolderApi;
/**
 * HolderAddressApi - axios parameter creator
 * @export
 */
exports.HolderAddressApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {HolderAddressCreation} holderAddressCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolderAddress: function (holderAddressCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'holderAddressCreation' is not null or undefined
                            common_1.assertParamExists('createHolderAddress', 'holderAddressCreation', holderAddressCreation);
                            localVarPath = "/api/holder-address";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(holderAddressCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolderAddress: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteHolderAddress', 'id', id);
                            localVarPath = "/api/holder-address/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [holderId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateHolderAddressAddress: function (page, size, projectId, holderId, chainId, address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/holder-address";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            if (holderId !== undefined) {
                                localVarQueryParameter['holderId'] = holderId;
                            }
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (address !== undefined) {
                                localVarQueryParameter['address'] = address;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * HolderAddressApi - functional programming interface
 * @export
 */
exports.HolderAddressApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.HolderAddressApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {HolderAddressCreation} holderAddressCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolderAddress: function (holderAddressCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createHolderAddress(holderAddressCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolderAddress: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteHolderAddress(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [holderId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateHolderAddressAddress: function (page, size, projectId, holderId, chainId, address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateHolderAddressAddress(page, size, projectId, holderId, chainId, address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * HolderAddressApi - factory interface
 * @export
 */
exports.HolderAddressApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.HolderAddressApiFp(configuration);
    return {
        /**
         *
         * @param {HolderAddressCreation} holderAddressCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolderAddress: function (holderAddressCreation, options) {
            return localVarFp.createHolderAddress(holderAddressCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolderAddress: function (id, options) {
            return localVarFp.deleteHolderAddress(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [holderId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateHolderAddressAddress: function (page, size, projectId, holderId, chainId, address, options) {
            return localVarFp.paginateHolderAddressAddress(page, size, projectId, holderId, chainId, address, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * HolderAddressApi - object-oriented interface
 * @export
 * @class HolderAddressApi
 * @extends {BaseAPI}
 */
var HolderAddressApi = /** @class */ (function (_super) {
    __extends(HolderAddressApi, _super);
    function HolderAddressApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {HolderAddressCreation} holderAddressCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderAddressApi
     */
    HolderAddressApi.prototype.createHolderAddress = function (holderAddressCreation, options) {
        var _this = this;
        return exports.HolderAddressApiFp(this.configuration).createHolderAddress(holderAddressCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderAddressApi
     */
    HolderAddressApi.prototype.deleteHolderAddress = function (id, options) {
        var _this = this;
        return exports.HolderAddressApiFp(this.configuration).deleteHolderAddress(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [projectId]
     * @param {string} [holderId]
     * @param {string} [chainId]
     * @param {string} [address]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderAddressApi
     */
    HolderAddressApi.prototype.paginateHolderAddressAddress = function (page, size, projectId, holderId, chainId, address, options) {
        var _this = this;
        return exports.HolderAddressApiFp(this.configuration).paginateHolderAddressAddress(page, size, projectId, holderId, chainId, address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HolderAddressApi;
}(base_1.BaseAPI));
exports.HolderAddressApi = HolderAddressApi;
/**
 * HolderGroupApi - axios parameter creator
 * @export
 */
exports.HolderGroupApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {HolderGroupCreation} holderGroupCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolderGroup: function (holderGroupCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'holderGroupCreation' is not null or undefined
                            common_1.assertParamExists('createHolderGroup', 'holderGroupCreation', holderGroupCreation);
                            localVarPath = "/api/holder-group";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(holderGroupCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolderGroup: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteHolderGroup', 'id', id);
                            localVarPath = "/api/holder-group/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolderGroup: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getHolderGroup', 'id', id);
                            localVarPath = "/api/holder-group/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {HolderGroupUpdates} holderGroupUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHolderGroup: function (id, holderGroupUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateHolderGroup', 'id', id);
                            // verify required parameter 'holderGroupUpdates' is not null or undefined
                            common_1.assertParamExists('updateHolderGroup', 'holderGroupUpdates', holderGroupUpdates);
                            localVarPath = "/api/holder-group/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(holderGroupUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * HolderGroupApi - functional programming interface
 * @export
 */
exports.HolderGroupApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.HolderGroupApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {HolderGroupCreation} holderGroupCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolderGroup: function (holderGroupCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createHolderGroup(holderGroupCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolderGroup: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteHolderGroup(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolderGroup: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getHolderGroup(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {HolderGroupUpdates} holderGroupUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHolderGroup: function (id, holderGroupUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateHolderGroup(id, holderGroupUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * HolderGroupApi - factory interface
 * @export
 */
exports.HolderGroupApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.HolderGroupApiFp(configuration);
    return {
        /**
         *
         * @param {HolderGroupCreation} holderGroupCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolderGroup: function (holderGroupCreation, options) {
            return localVarFp.createHolderGroup(holderGroupCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolderGroup: function (id, options) {
            return localVarFp.deleteHolderGroup(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolderGroup: function (id, options) {
            return localVarFp.getHolderGroup(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {HolderGroupUpdates} holderGroupUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHolderGroup: function (id, holderGroupUpdates, options) {
            return localVarFp.updateHolderGroup(id, holderGroupUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * HolderGroupApi - object-oriented interface
 * @export
 * @class HolderGroupApi
 * @extends {BaseAPI}
 */
var HolderGroupApi = /** @class */ (function (_super) {
    __extends(HolderGroupApi, _super);
    function HolderGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {HolderGroupCreation} holderGroupCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderGroupApi
     */
    HolderGroupApi.prototype.createHolderGroup = function (holderGroupCreation, options) {
        var _this = this;
        return exports.HolderGroupApiFp(this.configuration).createHolderGroup(holderGroupCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderGroupApi
     */
    HolderGroupApi.prototype.deleteHolderGroup = function (id, options) {
        var _this = this;
        return exports.HolderGroupApiFp(this.configuration).deleteHolderGroup(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderGroupApi
     */
    HolderGroupApi.prototype.getHolderGroup = function (id, options) {
        var _this = this;
        return exports.HolderGroupApiFp(this.configuration).getHolderGroup(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {HolderGroupUpdates} holderGroupUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolderGroupApi
     */
    HolderGroupApi.prototype.updateHolderGroup = function (id, holderGroupUpdates, options) {
        var _this = this;
        return exports.HolderGroupApiFp(this.configuration).updateHolderGroup(id, holderGroupUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HolderGroupApi;
}(base_1.BaseAPI));
exports.HolderGroupApi = HolderGroupApi;
/**
 * IncidentApi - axios parameter creator
 * @export
 */
exports.IncidentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {IncidentCreation} incidentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncident: function (incidentCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'incidentCreation' is not null or undefined
                            common_1.assertParamExists('createIncident', 'incidentCreation', incidentCreation);
                            localVarPath = "/api/incident";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(incidentCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncident: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteIncident', 'id', id);
                            localVarPath = "/api/incident/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncident: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getIncident', 'id', id);
                            localVarPath = "/api/incident/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncidentClusterGraph: function (id, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getIncidentClusterGraph', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('getIncidentClusterGraph', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('getIncidentClusterGraph', 'size', size);
                            localVarPath = "/api/incident/{id}/cluster-graph"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIncidentHolder: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listIncidentHolder', 'id', id);
                            localVarPath = "/api/incident/{id}/holder-graph"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [holderId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {string} [title]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateIncident: function (page, size, projectId, holderId, chainId, address, title, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/incident";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            if (holderId !== undefined) {
                                localVarQueryParameter['holderId'] = holderId;
                            }
                            if (chainId !== undefined) {
                                localVarQueryParameter['chainId'] = chainId;
                            }
                            if (address !== undefined) {
                                localVarQueryParameter['address'] = address;
                            }
                            if (title !== undefined) {
                                localVarQueryParameter['title'] = title;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IncidentAnnotationUpdates} incidentAnnotationUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIncidentAnnotation: function (id, incidentAnnotationUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('patchIncidentAnnotation', 'id', id);
                            // verify required parameter 'incidentAnnotationUpdates' is not null or undefined
                            common_1.assertParamExists('patchIncidentAnnotation', 'incidentAnnotationUpdates', incidentAnnotationUpdates);
                            localVarPath = "/api/incident/{id}/annotation"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(incidentAnnotationUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {'OPEN' | 'IN_REVIEW' | 'CLOSED'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIncidentStatus: function (id, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('patchIncidentStatus', 'id', id);
                            // verify required parameter 'status' is not null or undefined
                            common_1.assertParamExists('patchIncidentStatus', 'status', status);
                            localVarPath = "/api/incident/{id}/status/{status}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "status" + "}", encodeURIComponent(String(status)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * IncidentApi - functional programming interface
 * @export
 */
exports.IncidentApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.IncidentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {IncidentCreation} incidentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncident: function (incidentCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createIncident(incidentCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncident: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteIncident(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncident: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getIncident(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncidentClusterGraph: function (id, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getIncidentClusterGraph(id, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIncidentHolder: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listIncidentHolder(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [holderId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {string} [title]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateIncident: function (page, size, projectId, holderId, chainId, address, title, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateIncident(page, size, projectId, holderId, chainId, address, title, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IncidentAnnotationUpdates} incidentAnnotationUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIncidentAnnotation: function (id, incidentAnnotationUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchIncidentAnnotation(id, incidentAnnotationUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {'OPEN' | 'IN_REVIEW' | 'CLOSED'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIncidentStatus: function (id, status, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchIncidentStatus(id, status, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * IncidentApi - factory interface
 * @export
 */
exports.IncidentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.IncidentApiFp(configuration);
    return {
        /**
         *
         * @param {IncidentCreation} incidentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncident: function (incidentCreation, options) {
            return localVarFp.createIncident(incidentCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncident: function (id, options) {
            return localVarFp.deleteIncident(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncident: function (id, options) {
            return localVarFp.getIncident(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncidentClusterGraph: function (id, page, size, options) {
            return localVarFp.getIncidentClusterGraph(id, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIncidentHolder: function (id, options) {
            return localVarFp.listIncidentHolder(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [projectId]
         * @param {string} [holderId]
         * @param {string} [chainId]
         * @param {string} [address]
         * @param {string} [title]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateIncident: function (page, size, projectId, holderId, chainId, address, title, options) {
            return localVarFp.paginateIncident(page, size, projectId, holderId, chainId, address, title, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {IncidentAnnotationUpdates} incidentAnnotationUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIncidentAnnotation: function (id, incidentAnnotationUpdates, options) {
            return localVarFp.patchIncidentAnnotation(id, incidentAnnotationUpdates, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {'OPEN' | 'IN_REVIEW' | 'CLOSED'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchIncidentStatus: function (id, status, options) {
            return localVarFp.patchIncidentStatus(id, status, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * IncidentApi - object-oriented interface
 * @export
 * @class IncidentApi
 * @extends {BaseAPI}
 */
var IncidentApi = /** @class */ (function (_super) {
    __extends(IncidentApi, _super);
    function IncidentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {IncidentCreation} incidentCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentApi
     */
    IncidentApi.prototype.createIncident = function (incidentCreation, options) {
        var _this = this;
        return exports.IncidentApiFp(this.configuration).createIncident(incidentCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentApi
     */
    IncidentApi.prototype.deleteIncident = function (id, options) {
        var _this = this;
        return exports.IncidentApiFp(this.configuration).deleteIncident(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentApi
     */
    IncidentApi.prototype.getIncident = function (id, options) {
        var _this = this;
        return exports.IncidentApiFp(this.configuration).getIncident(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentApi
     */
    IncidentApi.prototype.getIncidentClusterGraph = function (id, page, size, options) {
        var _this = this;
        return exports.IncidentApiFp(this.configuration).getIncidentClusterGraph(id, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentApi
     */
    IncidentApi.prototype.listIncidentHolder = function (id, options) {
        var _this = this;
        return exports.IncidentApiFp(this.configuration).listIncidentHolder(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [projectId]
     * @param {string} [holderId]
     * @param {string} [chainId]
     * @param {string} [address]
     * @param {string} [title]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentApi
     */
    IncidentApi.prototype.paginateIncident = function (page, size, projectId, holderId, chainId, address, title, options) {
        var _this = this;
        return exports.IncidentApiFp(this.configuration).paginateIncident(page, size, projectId, holderId, chainId, address, title, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {IncidentAnnotationUpdates} incidentAnnotationUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentApi
     */
    IncidentApi.prototype.patchIncidentAnnotation = function (id, incidentAnnotationUpdates, options) {
        var _this = this;
        return exports.IncidentApiFp(this.configuration).patchIncidentAnnotation(id, incidentAnnotationUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {'OPEN' | 'IN_REVIEW' | 'CLOSED'} status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentApi
     */
    IncidentApi.prototype.patchIncidentStatus = function (id, status, options) {
        var _this = this;
        return exports.IncidentApiFp(this.configuration).patchIncidentStatus(id, status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IncidentApi;
}(base_1.BaseAPI));
exports.IncidentApi = IncidentApi;
/**
 * IncidentAddressScanApi - axios parameter creator
 * @export
 */
exports.IncidentAddressScanApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {IncidentAddressScanCreation} incidentAddressScanCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncidentAddressScan: function (incidentAddressScanCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'incidentAddressScanCreation' is not null or undefined
                            common_1.assertParamExists('createIncidentAddressScan', 'incidentAddressScanCreation', incidentAddressScanCreation);
                            localVarPath = "/api/incident-address-scan";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(incidentAddressScanCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncidentAddressScan: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteIncidentAddressScan', 'id', id);
                            localVarPath = "/api/incident-address-scan/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [incidentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateIncidentAddressScan: function (page, size, incidentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/incident-address-scan";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (incidentId !== undefined) {
                                localVarQueryParameter['incidentId'] = incidentId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * IncidentAddressScanApi - functional programming interface
 * @export
 */
exports.IncidentAddressScanApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.IncidentAddressScanApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {IncidentAddressScanCreation} incidentAddressScanCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncidentAddressScan: function (incidentAddressScanCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createIncidentAddressScan(incidentAddressScanCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncidentAddressScan: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteIncidentAddressScan(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [incidentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateIncidentAddressScan: function (page, size, incidentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateIncidentAddressScan(page, size, incidentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * IncidentAddressScanApi - factory interface
 * @export
 */
exports.IncidentAddressScanApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.IncidentAddressScanApiFp(configuration);
    return {
        /**
         *
         * @param {IncidentAddressScanCreation} incidentAddressScanCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncidentAddressScan: function (incidentAddressScanCreation, options) {
            return localVarFp.createIncidentAddressScan(incidentAddressScanCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncidentAddressScan: function (id, options) {
            return localVarFp.deleteIncidentAddressScan(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [incidentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateIncidentAddressScan: function (page, size, incidentId, options) {
            return localVarFp.paginateIncidentAddressScan(page, size, incidentId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * IncidentAddressScanApi - object-oriented interface
 * @export
 * @class IncidentAddressScanApi
 * @extends {BaseAPI}
 */
var IncidentAddressScanApi = /** @class */ (function (_super) {
    __extends(IncidentAddressScanApi, _super);
    function IncidentAddressScanApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {IncidentAddressScanCreation} incidentAddressScanCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentAddressScanApi
     */
    IncidentAddressScanApi.prototype.createIncidentAddressScan = function (incidentAddressScanCreation, options) {
        var _this = this;
        return exports.IncidentAddressScanApiFp(this.configuration).createIncidentAddressScan(incidentAddressScanCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentAddressScanApi
     */
    IncidentAddressScanApi.prototype.deleteIncidentAddressScan = function (id, options) {
        var _this = this;
        return exports.IncidentAddressScanApiFp(this.configuration).deleteIncidentAddressScan(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [incidentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentAddressScanApi
     */
    IncidentAddressScanApi.prototype.paginateIncidentAddressScan = function (page, size, incidentId, options) {
        var _this = this;
        return exports.IncidentAddressScanApiFp(this.configuration).paginateIncidentAddressScan(page, size, incidentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IncidentAddressScanApi;
}(base_1.BaseAPI));
exports.IncidentAddressScanApi = IncidentAddressScanApi;
/**
 * IncidentClusterApi - axios parameter creator
 * @export
 */
exports.IncidentClusterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {IncidentClusterBulkCreation} incidentClusterBulkCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncidentCluster: function (incidentClusterBulkCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'incidentClusterBulkCreation' is not null or undefined
                            common_1.assertParamExists('createIncidentCluster', 'incidentClusterBulkCreation', incidentClusterBulkCreation);
                            localVarPath = "/api/incident-cluster";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(incidentClusterBulkCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncidentCluster: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteIncidentCluster', 'id', id);
                            localVarPath = "/api/incident-cluster/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [incidentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateIncidentCluster: function (page, size, incidentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/incident-cluster";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (incidentId !== undefined) {
                                localVarQueryParameter['incidentId'] = incidentId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IncidentClusterUpdates} incidentClusterUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncidentCluster: function (id, incidentClusterUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateIncidentCluster', 'id', id);
                            // verify required parameter 'incidentClusterUpdates' is not null or undefined
                            common_1.assertParamExists('updateIncidentCluster', 'incidentClusterUpdates', incidentClusterUpdates);
                            localVarPath = "/api/incident-cluster/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(incidentClusterUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * IncidentClusterApi - functional programming interface
 * @export
 */
exports.IncidentClusterApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.IncidentClusterApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {IncidentClusterBulkCreation} incidentClusterBulkCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncidentCluster: function (incidentClusterBulkCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createIncidentCluster(incidentClusterBulkCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncidentCluster: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteIncidentCluster(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [incidentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateIncidentCluster: function (page, size, incidentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateIncidentCluster(page, size, incidentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {IncidentClusterUpdates} incidentClusterUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncidentCluster: function (id, incidentClusterUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateIncidentCluster(id, incidentClusterUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * IncidentClusterApi - factory interface
 * @export
 */
exports.IncidentClusterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.IncidentClusterApiFp(configuration);
    return {
        /**
         *
         * @param {IncidentClusterBulkCreation} incidentClusterBulkCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncidentCluster: function (incidentClusterBulkCreation, options) {
            return localVarFp.createIncidentCluster(incidentClusterBulkCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIncidentCluster: function (id, options) {
            return localVarFp.deleteIncidentCluster(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [incidentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateIncidentCluster: function (page, size, incidentId, options) {
            return localVarFp.paginateIncidentCluster(page, size, incidentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {IncidentClusterUpdates} incidentClusterUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncidentCluster: function (id, incidentClusterUpdates, options) {
            return localVarFp.updateIncidentCluster(id, incidentClusterUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * IncidentClusterApi - object-oriented interface
 * @export
 * @class IncidentClusterApi
 * @extends {BaseAPI}
 */
var IncidentClusterApi = /** @class */ (function (_super) {
    __extends(IncidentClusterApi, _super);
    function IncidentClusterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {IncidentClusterBulkCreation} incidentClusterBulkCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentClusterApi
     */
    IncidentClusterApi.prototype.createIncidentCluster = function (incidentClusterBulkCreation, options) {
        var _this = this;
        return exports.IncidentClusterApiFp(this.configuration).createIncidentCluster(incidentClusterBulkCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentClusterApi
     */
    IncidentClusterApi.prototype.deleteIncidentCluster = function (id, options) {
        var _this = this;
        return exports.IncidentClusterApiFp(this.configuration).deleteIncidentCluster(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [incidentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentClusterApi
     */
    IncidentClusterApi.prototype.paginateIncidentCluster = function (page, size, incidentId, options) {
        var _this = this;
        return exports.IncidentClusterApiFp(this.configuration).paginateIncidentCluster(page, size, incidentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {IncidentClusterUpdates} incidentClusterUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentClusterApi
     */
    IncidentClusterApi.prototype.updateIncidentCluster = function (id, incidentClusterUpdates, options) {
        var _this = this;
        return exports.IncidentClusterApiFp(this.configuration).updateIncidentCluster(id, incidentClusterUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IncidentClusterApi;
}(base_1.BaseAPI));
exports.IncidentClusterApi = IncidentClusterApi;
/**
 * LabelApi - axios parameter creator
 * @export
 */
exports.LabelApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns all labels.
         * @summary Find all labels
         * @param {string} [categoryId] Label Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabels: function (categoryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/label";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (categoryId !== undefined) {
                                localVarQueryParameter['categoryId'] = categoryId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * LabelApi - functional programming interface
 * @export
 */
exports.LabelApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.LabelApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns all labels.
         * @summary Find all labels
         * @param {string} [categoryId] Label Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabels: function (categoryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listLabels(categoryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * LabelApi - factory interface
 * @export
 */
exports.LabelApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.LabelApiFp(configuration);
    return {
        /**
         * Returns all labels.
         * @summary Find all labels
         * @param {string} [categoryId] Label Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabels: function (categoryId, options) {
            return localVarFp.listLabels(categoryId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * LabelApi - object-oriented interface
 * @export
 * @class LabelApi
 * @extends {BaseAPI}
 */
var LabelApi = /** @class */ (function (_super) {
    __extends(LabelApi, _super);
    function LabelApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns all labels.
     * @summary Find all labels
     * @param {string} [categoryId] Label Category ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelApi
     */
    LabelApi.prototype.listLabels = function (categoryId, options) {
        var _this = this;
        return exports.LabelApiFp(this.configuration).listLabels(categoryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LabelApi;
}(base_1.BaseAPI));
exports.LabelApi = LabelApi;
/**
 * LabelCategoryApi - axios parameter creator
 * @export
 */
exports.LabelCategoryApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns all label categories.
         * @summary Find all label categories
         * @param {string} [projectId] Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabelCategories: function (projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/label-category";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * LabelCategoryApi - functional programming interface
 * @export
 */
exports.LabelCategoryApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.LabelCategoryApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns all label categories.
         * @summary Find all label categories
         * @param {string} [projectId] Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabelCategories: function (projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listLabelCategories(projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * LabelCategoryApi - factory interface
 * @export
 */
exports.LabelCategoryApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.LabelCategoryApiFp(configuration);
    return {
        /**
         * Returns all label categories.
         * @summary Find all label categories
         * @param {string} [projectId] Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabelCategories: function (projectId, options) {
            return localVarFp.listLabelCategories(projectId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * LabelCategoryApi - object-oriented interface
 * @export
 * @class LabelCategoryApi
 * @extends {BaseAPI}
 */
var LabelCategoryApi = /** @class */ (function (_super) {
    __extends(LabelCategoryApi, _super);
    function LabelCategoryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns all label categories.
     * @summary Find all label categories
     * @param {string} [projectId] Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelCategoryApi
     */
    LabelCategoryApi.prototype.listLabelCategories = function (projectId, options) {
        var _this = this;
        return exports.LabelCategoryApiFp(this.configuration).listLabelCategories(projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LabelCategoryApi;
}(base_1.BaseAPI));
exports.LabelCategoryApi = LabelCategoryApi;
/**
 * MarketPriceApi - axios parameter creator
 * @export
 */
exports.MarketPriceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} provider
         * @param {string} marketName
         * @param {number} startFrom
         * @param {number} startTo
         * @param {number} resolutionMin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateMarketPrice: function (provider, marketName, startFrom, startTo, resolutionMin, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'provider' is not null or undefined
                            common_1.assertParamExists('paginateMarketPrice', 'provider', provider);
                            // verify required parameter 'marketName' is not null or undefined
                            common_1.assertParamExists('paginateMarketPrice', 'marketName', marketName);
                            // verify required parameter 'startFrom' is not null or undefined
                            common_1.assertParamExists('paginateMarketPrice', 'startFrom', startFrom);
                            // verify required parameter 'startTo' is not null or undefined
                            common_1.assertParamExists('paginateMarketPrice', 'startTo', startTo);
                            // verify required parameter 'resolutionMin' is not null or undefined
                            common_1.assertParamExists('paginateMarketPrice', 'resolutionMin', resolutionMin);
                            localVarPath = "/api/market-price";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (provider !== undefined) {
                                localVarQueryParameter['provider'] = provider;
                            }
                            if (marketName !== undefined) {
                                localVarQueryParameter['marketName'] = marketName;
                            }
                            if (startFrom !== undefined) {
                                localVarQueryParameter['startFrom'] = startFrom;
                            }
                            if (startTo !== undefined) {
                                localVarQueryParameter['startTo'] = startTo;
                            }
                            if (resolutionMin !== undefined) {
                                localVarQueryParameter['resolutionMin'] = resolutionMin;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * MarketPriceApi - functional programming interface
 * @export
 */
exports.MarketPriceApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.MarketPriceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} provider
         * @param {string} marketName
         * @param {number} startFrom
         * @param {number} startTo
         * @param {number} resolutionMin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateMarketPrice: function (provider, marketName, startFrom, startTo, resolutionMin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateMarketPrice(provider, marketName, startFrom, startTo, resolutionMin, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * MarketPriceApi - factory interface
 * @export
 */
exports.MarketPriceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.MarketPriceApiFp(configuration);
    return {
        /**
         *
         * @param {string} provider
         * @param {string} marketName
         * @param {number} startFrom
         * @param {number} startTo
         * @param {number} resolutionMin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateMarketPrice: function (provider, marketName, startFrom, startTo, resolutionMin, options) {
            return localVarFp.paginateMarketPrice(provider, marketName, startFrom, startTo, resolutionMin, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * MarketPriceApi - object-oriented interface
 * @export
 * @class MarketPriceApi
 * @extends {BaseAPI}
 */
var MarketPriceApi = /** @class */ (function (_super) {
    __extends(MarketPriceApi, _super);
    function MarketPriceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} provider
     * @param {string} marketName
     * @param {number} startFrom
     * @param {number} startTo
     * @param {number} resolutionMin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketPriceApi
     */
    MarketPriceApi.prototype.paginateMarketPrice = function (provider, marketName, startFrom, startTo, resolutionMin, options) {
        var _this = this;
        return exports.MarketPriceApiFp(this.configuration).paginateMarketPrice(provider, marketName, startFrom, startTo, resolutionMin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MarketPriceApi;
}(base_1.BaseAPI));
exports.MarketPriceApi = MarketPriceApi;
/**
 * MediumApi - axios parameter creator
 * @export
 */
exports.MediumApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medium: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/medium";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * MediumApi - functional programming interface
 * @export
 */
exports.MediumApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.MediumApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medium: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.medium(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * MediumApi - factory interface
 * @export
 */
exports.MediumApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.MediumApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medium: function (options) {
            return localVarFp.medium(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * MediumApi - object-oriented interface
 * @export
 * @class MediumApi
 * @extends {BaseAPI}
 */
var MediumApi = /** @class */ (function (_super) {
    __extends(MediumApi, _super);
    function MediumApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediumApi
     */
    MediumApi.prototype.medium = function (options) {
        var _this = this;
        return exports.MediumApiFp(this.configuration).medium(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MediumApi;
}(base_1.BaseAPI));
exports.MediumApi = MediumApi;
/**
 * ProjectApi - axios parameter creator
 * @export
 */
exports.ProjectApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {ProjectCreation} projectCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: function (projectCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'projectCreation' is not null or undefined
                            common_1.assertParamExists('createProject', 'projectCreation', projectCreation);
                            localVarPath = "/api/project";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(projectCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteProject', 'id', id);
                            localVarPath = "/api/project/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getProject', 'id', id);
                            localVarPath = "/api/project/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectFlowLabeling: function (id, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getProjectFlowLabeling', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('getProjectFlowLabeling', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('getProjectFlowLabeling', 'size', size);
                            localVarPath = "/api/project/{id}/flow-labeling"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectHolderGroups: function (id, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getProjectHolderGroups', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('getProjectHolderGroups', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('getProjectHolderGroups', 'size', size);
                            localVarPath = "/api/project/{id}/holder-group"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectSummary: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getProjectSummary', 'id', id);
                            localVarPath = "/api/project/{id}/summary"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {ProjectUpdates} projectUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: function (id, projectUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateProject', 'id', id);
                            // verify required parameter 'projectUpdates' is not null or undefined
                            common_1.assertParamExists('updateProject', 'projectUpdates', projectUpdates);
                            localVarPath = "/api/project/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(projectUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ProjectApi - functional programming interface
 * @export
 */
exports.ProjectApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ProjectApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ProjectCreation} projectCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: function (projectCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createProject(projectCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProject(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProject(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectFlowLabeling: function (id, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProjectFlowLabeling(id, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectHolderGroups: function (id, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProjectHolderGroups(id, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectSummary: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProjectSummary(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {ProjectUpdates} projectUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: function (id, projectUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProject(id, projectUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ProjectApi - factory interface
 * @export
 */
exports.ProjectApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ProjectApiFp(configuration);
    return {
        /**
         *
         * @param {ProjectCreation} projectCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: function (projectCreation, options) {
            return localVarFp.createProject(projectCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: function (id, options) {
            return localVarFp.deleteProject(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: function (id, options) {
            return localVarFp.getProject(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectFlowLabeling: function (id, page, size, options) {
            return localVarFp.getProjectFlowLabeling(id, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {number} page
         * @param {number} size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectHolderGroups: function (id, page, size, options) {
            return localVarFp.getProjectHolderGroups(id, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectSummary: function (id, options) {
            return localVarFp.getProjectSummary(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {ProjectUpdates} projectUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: function (id, projectUpdates, options) {
            return localVarFp.updateProject(id, projectUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ProjectApi - object-oriented interface
 * @export
 * @class ProjectApi
 * @extends {BaseAPI}
 */
var ProjectApi = /** @class */ (function (_super) {
    __extends(ProjectApi, _super);
    function ProjectApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {ProjectCreation} projectCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.createProject = function (projectCreation, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).createProject(projectCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.deleteProject = function (id, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).deleteProject(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.getProject = function (id, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).getProject(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.getProjectFlowLabeling = function (id, page, size, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).getProjectFlowLabeling(id, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {number} page
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.getProjectHolderGroups = function (id, page, size, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).getProjectHolderGroups(id, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.getProjectSummary = function (id, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).getProjectSummary(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {ProjectUpdates} projectUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.updateProject = function (id, projectUpdates, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).updateProject(id, projectUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProjectApi;
}(base_1.BaseAPI));
exports.ProjectApi = ProjectApi;
/**
 * ReadmeApi - axios parameter creator
 * @export
 */
exports.ReadmeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackReadmeLogin: function (code, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            common_1.assertParamExists('callbackReadmeLogin', 'code', code);
                            localVarPath = "/api/readme/callback";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInReadme: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/readme/sign-in";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ReadmeApi - functional programming interface
 * @export
 */
exports.ReadmeApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ReadmeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackReadmeLogin: function (code, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.callbackReadmeLogin(code, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInReadme: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.signInReadme(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ReadmeApi - factory interface
 * @export
 */
exports.ReadmeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ReadmeApiFp(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackReadmeLogin: function (code, options) {
            return localVarFp.callbackReadmeLogin(code, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInReadme: function (options) {
            return localVarFp.signInReadme(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ReadmeApi - object-oriented interface
 * @export
 * @class ReadmeApi
 * @extends {BaseAPI}
 */
var ReadmeApi = /** @class */ (function (_super) {
    __extends(ReadmeApi, _super);
    function ReadmeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReadmeApi
     */
    ReadmeApi.prototype.callbackReadmeLogin = function (code, options) {
        var _this = this;
        return exports.ReadmeApiFp(this.configuration).callbackReadmeLogin(code, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReadmeApi
     */
    ReadmeApi.prototype.signInReadme = function (options) {
        var _this = this;
        return exports.ReadmeApiFp(this.configuration).signInReadme(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReadmeApi;
}(base_1.BaseAPI));
exports.ReadmeApi = ReadmeApi;
/**
 * ReportTicketApi - axios parameter creator
 * @export
 */
exports.ReportTicketApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a new report ticket.
         * @summary Create report ticket
         * @param {ReportTicketCreation} reportTicketCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportTicket: function (reportTicketCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reportTicketCreation' is not null or undefined
                            common_1.assertParamExists('createReportTicket', 'reportTicketCreation', reportTicketCreation);
                            localVarPath = "/api/report-ticket";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(reportTicketCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ReportTicketApi - functional programming interface
 * @export
 */
exports.ReportTicketApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ReportTicketApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a new report ticket.
         * @summary Create report ticket
         * @param {ReportTicketCreation} reportTicketCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportTicket: function (reportTicketCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createReportTicket(reportTicketCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ReportTicketApi - factory interface
 * @export
 */
exports.ReportTicketApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ReportTicketApiFp(configuration);
    return {
        /**
         * Create a new report ticket.
         * @summary Create report ticket
         * @param {ReportTicketCreation} reportTicketCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportTicket: function (reportTicketCreation, options) {
            return localVarFp.createReportTicket(reportTicketCreation, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ReportTicketApi - object-oriented interface
 * @export
 * @class ReportTicketApi
 * @extends {BaseAPI}
 */
var ReportTicketApi = /** @class */ (function (_super) {
    __extends(ReportTicketApi, _super);
    function ReportTicketApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new report ticket.
     * @summary Create report ticket
     * @param {ReportTicketCreation} reportTicketCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTicketApi
     */
    ReportTicketApi.prototype.createReportTicket = function (reportTicketCreation, options) {
        var _this = this;
        return exports.ReportTicketApiFp(this.configuration).createReportTicket(reportTicketCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReportTicketApi;
}(base_1.BaseAPI));
exports.ReportTicketApi = ReportTicketApi;
/**
 * RequestDemoApi - axios parameter creator
 * @export
 */
exports.RequestDemoApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Request Demo
         * @summary Request Demo
         * @param {RequestDemoForm} requestDemoForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDemo: function (requestDemoForm, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'requestDemoForm' is not null or undefined
                            common_1.assertParamExists('requestDemo', 'requestDemoForm', requestDemoForm);
                            localVarPath = "/api/demo";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestDemoForm, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * RequestDemoApi - functional programming interface
 * @export
 */
exports.RequestDemoApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.RequestDemoApiAxiosParamCreator(configuration);
    return {
        /**
         * Request Demo
         * @summary Request Demo
         * @param {RequestDemoForm} requestDemoForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDemo: function (requestDemoForm, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestDemo(requestDemoForm, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * RequestDemoApi - factory interface
 * @export
 */
exports.RequestDemoApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.RequestDemoApiFp(configuration);
    return {
        /**
         * Request Demo
         * @summary Request Demo
         * @param {RequestDemoForm} requestDemoForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDemo: function (requestDemoForm, options) {
            return localVarFp.requestDemo(requestDemoForm, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * RequestDemoApi - object-oriented interface
 * @export
 * @class RequestDemoApi
 * @extends {BaseAPI}
 */
var RequestDemoApi = /** @class */ (function (_super) {
    __extends(RequestDemoApi, _super);
    function RequestDemoApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Request Demo
     * @summary Request Demo
     * @param {RequestDemoForm} requestDemoForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestDemoApi
     */
    RequestDemoApi.prototype.requestDemo = function (requestDemoForm, options) {
        var _this = this;
        return exports.RequestDemoApiFp(this.configuration).requestDemo(requestDemoForm, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RequestDemoApi;
}(base_1.BaseAPI));
exports.RequestDemoApi = RequestDemoApi;
/**
 * RuleApi - axios parameter creator
 * @export
 */
exports.RuleApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRule: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getRule', 'id', id);
                            localVarPath = "/api/rule/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * RuleApi - functional programming interface
 * @export
 */
exports.RuleApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.RuleApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRule: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRule(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * RuleApi - factory interface
 * @export
 */
exports.RuleApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.RuleApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRule: function (id, options) {
            return localVarFp.getRule(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * RuleApi - object-oriented interface
 * @export
 * @class RuleApi
 * @extends {BaseAPI}
 */
var RuleApi = /** @class */ (function (_super) {
    __extends(RuleApi, _super);
    function RuleApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    RuleApi.prototype.getRule = function (id, options) {
        var _this = this;
        return exports.RuleApiFp(this.configuration).getRule(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RuleApi;
}(base_1.BaseAPI));
exports.RuleApi = RuleApi;
/**
 * TxApi - axios parameter creator
 * @export
 */
exports.TxApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a page of transaction history. The history records are ordered by transaction creation time.
         * @summary Find transaction history
         * @param {number} page
         * @param {number} size
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateTx: function (page, size, projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('paginateTx', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('paginateTx', 'size', size);
                            localVarPath = "/api/tx";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication ApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)
                                // authentication OAuth required
                                // oauth required
                            ];
                        case 1:
                            // authentication ApiKey required
                            _a.sent();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)
                                // authentication UbApiKey required
                            ];
                        case 2:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            // authentication UbApiKey required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-KEY", configuration)
                                // authentication UbApiSign required
                            ];
                        case 3:
                            // authentication UbApiKey required
                            _a.sent();
                            // authentication UbApiSign required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-SIGN", configuration)
                                // authentication UbApiTs required
                            ];
                        case 4:
                            // authentication UbApiSign required
                            _a.sent();
                            // authentication UbApiTs required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "UNBLOCK-TS", configuration)];
                        case 5:
                            // authentication UbApiTs required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * TxApi - functional programming interface
 * @export
 */
exports.TxApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.TxApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a page of transaction history. The history records are ordered by transaction creation time.
         * @summary Find transaction history
         * @param {number} page
         * @param {number} size
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateTx: function (page, size, projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateTx(page, size, projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * TxApi - factory interface
 * @export
 */
exports.TxApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.TxApiFp(configuration);
    return {
        /**
         * Returns a page of transaction history. The history records are ordered by transaction creation time.
         * @summary Find transaction history
         * @param {number} page
         * @param {number} size
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateTx: function (page, size, projectId, options) {
            return localVarFp.paginateTx(page, size, projectId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * TxApi - object-oriented interface
 * @export
 * @class TxApi
 * @extends {BaseAPI}
 */
var TxApi = /** @class */ (function (_super) {
    __extends(TxApi, _super);
    function TxApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a page of transaction history. The history records are ordered by transaction creation time.
     * @summary Find transaction history
     * @param {number} page
     * @param {number} size
     * @param {string} [projectId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.paginateTx = function (page, size, projectId, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).paginateTx(page, size, projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TxApi;
}(base_1.BaseAPI));
exports.TxApi = TxApi;
